// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T16:19:24.026Z
// Property: The Vale at Baymeadows (ID: 6767906449167307)
// Collections: 23 amenities, 6 floorplans (live), 21 photos, 38 POIs, 5 reviews, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "6767906449167307",
  "property_external_id": "5648091",
  "property_zillow_url": "https://www.zillow.com/apartments/jacksonville-fl/courtney-meadows/5Xhwct/",
  "property_apartments_url": "https://www.apartments.com/the-vale-at-baymeadows-jacksonville-fl/39cps3d/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Vale+at+Baymeadows/data=!4m2!3m1!1s0x0:0xbe9e3820fa1ab8?sa=X&ved=2ahUKEwjN_NSogJuUAxUORjABHXqNH6EQ_BJ6BAgMEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "52980507672",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-vale-at-baymeadows",
  "property_name": "The Vale at Baymeadows",
  "property_website_url": "https://www.thevaleatbaymeadows.com/",
  "property_domain": "https://www.thevaleatbaymeadows.com",
  "property_address": "7820 Baymeadows Rd E",
  "property_full_address": "7820 Baymeadows Rd E, Jacksonville, FL 32256",
  "property_address_1": "7820 Baymeadows Rd E",
  "property_address_2": null,
  "property_address_city": "Jacksonville",
  "property_address_state": "FL",
  "property_address_zip_full": "32256-4637",
  "property_address_zip": "32256",
  "property_address_country": "US",
  "property_address_county": "Duval County",
  "property_neighborhood_address": "Deerwood",
  "property_address_latitude": "30.2303719",
  "property_address_longitude": "-81.5123235",
  "property_email": "vale@alapts.com",
  "property_phone": "(904) 998-4303",
  "property_call_tracking_phone": "904-467-7561",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern Southside living with a lakeside feel.</strong> Discover spacious one-, two-, and three-bedroom apartments with open layouts, in-home laundry, private outdoor space, and select lake or pool views—then explore available floor plans to find your fit.</p>",
  "property_long_description": "<p><strong>Modern Southside living with a lakeside feel.</strong> At The Vale at Baymeadows, you get spacious one-, two-, and three-bedroom apartments in Jacksonville’s Deerwood area, paired with everyday ease near Baymeadows Road, I-295, and Southside Boulevard. Choose open layouts with high ceilings, large closets, in-home washer/dryer, private patios or balconies, and select homes with lake or pool views, granite or quartz countertops, stainless steel appliances, and sleek white cabinetry.</p><p>Outside your door, spend the afternoon by the vacation-inspired <a href=\"/amenities\">pool and sundeck</a>, fit in a workout in the 24/7 fitness center, grill outdoors, rinse off at the car wash area, or make the most of the large off-leash dog park. Detached garages and extra storage add room for the things you bring with you.</p><p>Set minutes from St. Johns Town Center and close to Losco Regional Park, Hodges Stadium, UNF, and Deerwood’s dining and retail corridors, The Vale keeps shopping, green space, beaches, and major Jacksonville business hubs within easy reach. Explore <a href=\"/floor-plans\">available floor plans</a> and find the space that fits your day.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019e8a09-1e94-71ee-b836-648421bc9b7b.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas next to a building at dusk.",
    "public_id": "019e8a09-1e94-71ee-b836-648421bc9b7b",
    "storage_key": "property/6767906449167307/019e8a09-1e94-71ee-b836-648421bc9b7b.webp",
    "width": 1640,
    "height": 900
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "276",
  "property_year_built": "2001",
  "property_year_renovated": "2026",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.73913043478261",
  "property_admin_fee": "250",
  "property_application_fee": "85",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://9304426.onlineleasing.realpage.com/",
  "property_resident_portal_url": "https://thevaleatbaymeadows.loftliving.com/login",
  "property_apply_now_url": "https://9304426.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f8-2d20-7072-856d-40f1d60fbc55.webp",
  "property_primary_logo_media": {
    "alt_text": "The Vale at Baymeadows logo",
    "public_id": "019d02f8-2d20-7072-856d-40f1d60fbc55",
    "storage_key": "property/6767906449167307/019d02f8-2d20-7072-856d-40f1d60fbc55.webp",
    "width": 640,
    "height": 242
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f8-2d20-7072-856d-40f1d60fbc55.webp",
  "property_icon_media": {
    "alt_text": "The Vale at Baymeadows logo",
    "public_id": "019d02f8-2d20-7072-856d-40f1d60fbc55",
    "storage_key": "property/6767906449167307/019d02f8-2d20-7072-856d-40f1d60fbc55.webp",
    "width": 640,
    "height": 242
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019e8a1f-a0e9-77fc-8290-78a3573cd922.webp",
  "property_fav_icon_media": {
    "alt_text": "The Vale at Baymeadows logo",
    "public_id": "019e8a1f-a0e9-77fc-8290-78a3573cd922",
    "storage_key": "property/6767906449167307/019e8a1f-a0e9-77fc-8290-78a3573cd922.webp",
    "width": 3072,
    "height": 3071
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f8-3660-77bb-92ae-9e115db852a5.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Vale at Baymeadows logo",
    "public_id": "019d02f8-3660-77bb-92ae-9e115db852a5",
    "storage_key": "property/6767906449167307/019d02f8-3660-77bb-92ae-9e115db852a5.webp",
    "width": 640,
    "height": 242
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f8-3fc4-7523-95fa-1e58db29f45f.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Vale at Baymeadows logo.",
    "public_id": "019d02f8-3fc4-7523-95fa-1e58db29f45f",
    "storage_key": "property/6767906449167307/019d02f8-3fc4-7523-95fa-1e58db29f45f.webp",
    "width": 640,
    "height": 242
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#afbfad",
  "property_secondary_color": "#d0bca4",
  "property_font_color": "#888e86",
  "property_color_4": "#000000",
  "property_color_3": "#937b5c",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1-3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1-2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "827 - 1247",
  "property_sqft_min": "820",
  "property_sqft_max": "820",
  "property_price_range": "2025",
  "property_price_min": null,
  "property_price_max": "2025",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/TheValeatBaymeadows",
  "property_instagram_url": "https://www.instagram.com/thevaleatbaymeadows/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJjQzFfjU15IgRuBr6IDievgA",
  "property_youtube_url": "https://www.youtube.com/channel/UC-SEN_sMbax0XKdGiQTOEDQ",
  "property_yelp_url": "https://www.yelp.com/biz/villas-at-st-johns-jacksonville-3",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Vale at Baymeadows",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Convenience meets downtime at The Vale at Baymeadows.</strong> Power through a workout in the 24/7 fitness center, unwind by the pool, or fire up dinner at the outdoor grilling area. Package lockers, EV charging, a car wash area, detached garages, and extra storage keep the everyday easy, while select apartments add polished touches like stainless steel appliances, quartz or granite countertops, keyless entry, and lake or pool views.</p>",
  "property_home_floorplans_blurb": "<p><strong>Open layouts, polished finishes, and space that works.</strong> Explore one-, two-, and three-bedroom apartments at The Vale at Baymeadows with high ceilings, generous closets, in-home washers and dryers, and private patios or balconies. Select homes elevate the view with lake or pool outlooks, stainless steel appliances, quartz or granite countertops, sleek white cabinetry, and modern hardware—all ready to compare by layout, finish, and availability.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at The Vale at Baymeadows.</strong> Preview lakefront sunsets, palm-framed pool days, and an inviting sundeck made for lounging. Inside, discover open living areas, high ceilings, private balconies, and select kitchens with white cabinetry, granite countertops, and stainless steel appliances. Keep scrolling for a closer look at the fitness center, business lounge, detached garages, and large dog park.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Southside convenience, lakeside calm.</strong> From Baymeadows Road in Deerwood, The Vale keeps St. Johns Town Center, The Markets, The Strand, Cinemark Tinseltown, Touchton Road Park, UNF, and Deerwood Park’s office corridor close by. JTA Route 28, I-295, and J. Turner Butler Boulevard make wider Jacksonville easy to reach—then the pool, dog park, and lakeside setting bring the pace back down.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents notice the details.</strong> Reviews for The Vale at Baymeadows often highlight the clean, well-kept community, modern spacious apartments, high ceilings, open layouts, and roomy baths. The leasing team also earns praise for friendly, knowledgeable service, helpful tours, quick answers, and an easy, welcoming experience from first visit onward.</p>",
  "property_neighborhood_blurb": "<p><strong>Map your day from the heart of Deerwood.</strong> Baymeadows Road puts The Vale in the Southside’s easygoing flow—close to everyday dining, coffee stops, grocery runs, and open-air shopping across St. Johns Town Center, The Markets, and The Strand. Catch a movie at Cinemark Tinseltown, meet the trail at Touchton Road Park, or head toward UNF and Deerwood Park’s office corridor without crossing town. JTA Route 28 stops along Baymeadows/Southside, and quick connections to I-295 and J. Turner Butler Boulevard keep beaches, downtown, and the wider Jacksonville area within reach. After the map leads you out, a lakeside setting, pool, and dog park bring the day back to a quieter pace—see the community up close when you <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity spaces that work as hard as they relax.</strong> At The Vale at Baymeadows, your routine can move from a morning workout in the 24/7 fitness center to a sun-soaked break by the pool, then dinner at the outdoor grilling area without leaving the community. Practical perks make everyday tasks smoother, too, with package lockers, EV charging, a car wash area, detached garages, and extra storage options adding convenience where it counts.</p><p>Inside, open one-, two-, and three-bedroom apartments pair high ceilings and large closets with polished finishes like sleek white cabinetry, wood-style or ceramic tile flooring, and select homes with stainless steel appliances, quartz or granite countertops, keyless entry, and scenic lake or pool views. See more in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make The Vale at Baymeadows home?</strong> Start your application online for spacious one-, two-, or three-bedroom apartments with open layouts, high ceilings, in-home washer/dryer, and private patios or balconies—plus the lakeside ease and everyday convenience that make life here feel right from the start.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact The Vale at Baymeadows leasing team for help exploring spacious Southside apartments with a lakeside feel, everyday access near Baymeadows Road, I-295, and Southside Boulevard, and layouts that fit your day. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Vale at Baymeadows?</strong> Start here for quick answers about the community, leasing, amenities, and everyday living in our Southside Jacksonville apartments. If you need more details or want help finding the right layout, our leasing team is happy to help through <a href=\"/contact-us\">contact us</a>.</p>",
  "property_floorplans_blurb": "<p><strong>Find a floor plan that feels easy from the first walkthrough.</strong> Choose from one-, two-, and three-bedroom apartments with open living space, high ceilings, generous closets, and the everyday convenience of an in-home washer and dryer. Private patios or balconies give you room to step outside, while select layouts add scenic lake or pool views, stainless steel appliances, quartz or granite countertops, sleek white cabinetry, and modern hardware.</p><p>Whether you want a streamlined one-bedroom, a spacious two-bedroom with two baths, or a larger three-bedroom layout, The Vale at Baymeadows gives you options that balance comfort, storage, and style. Browse current availability, compare finishes and pricing, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see which apartment fits best.</p>",
  "property_gallery_blurb": "<p><strong>See the details come into focus.</strong> Browse the gallery for a first look at The Vale at Baymeadows: sunset reflections across the lake, palms framing the pool, and lounge seating that makes the sundeck feel instantly inviting. Inside, photos highlight open living areas, high ceilings, private balconies, and kitchens with sleek white cabinetry, granite countertops, and stainless steel appliances in select homes.</p><p>Keep clicking to spot the everyday spaces that add polish to your routine—from the fitness center and business lounge to detached garages and the large dog park. When a layout catches your eye, compare <a href=\"/floor-plans\">available floor plans</a>, explore <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your place on the map.</strong> Explore available apartments at The Vale at Baymeadows, then see how lakeside Southside living connects you to Baymeadows Road, I-295, Southside Boulevard, shopping, green space, beaches, and major Jacksonville business hubs.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living should feel simple.</strong> At The Vale at Baymeadows, cats and dogs have room to settle in with you, including a no-weight-limit policy and space for up to two pets per home. Start the day with a lap around the community, head to the <a href=\"/amenities\">large off-leash dog park</a> for fresh air, then come back to an apartment with practical comforts like large closets, in-home washer/dryer, and a patio or balcony in select layouts.</p><p>Set in Deerwood near everyday pet-care stops along Baymeadows Road, The Vale keeps walks, vet visits, supply runs, and downtime easy to manage. Explore <a href=\"/floor-plans\">roomy floor plans</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how your pet’s routine can fit here.</p>",
  "property_referafriend_blurb": "<p><strong>Share the lakeside Southside living you love.</strong> Invite a friend to discover spacious apartment layouts, everyday ease, and relaxing community spaces at The Vale at Baymeadows. Send a referral today and help them find their next home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made easy.</strong> Pay rent, submit maintenance requests, and manage your account from The Vale at Baymeadows—your Southside home base for modern layouts, everyday convenience, and a lakeside feel.</p>",
  "property_reviews_blurb": "<p><strong>See what stands out to reviewers.</strong> As you read The Vale at Baymeadows reviews, you’ll notice repeated praise for a community that feels clean, cared for, and easy to picture as home. Residents and tour guests call out the well-kept grounds, modern and spacious apartments, and standout touches like high ceilings, open layouts, and roomy baths.</p><p>The leasing experience gets just as much attention, with reviewers highlighting friendly, knowledgeable support from team members like Coy and Amayah. From thorough <a href=\"/schedule-a-tour\">apartment tours</a> to quick answers and welcoming service, reviewers describe the process as comfortable and stress-free. One review says it best: “5 stars all the way!”</p>",
  "property_created_at": "1773686232807",
  "property_scheduletour_blurb": "<p><strong>See the lakeside feel for yourself.</strong> Tour spacious one-, two-, and three-bedroom apartments with open layouts, high ceilings, large closets, in-home washer/dryer, and private patios or balconies. Visit The Vale at Baymeadows and picture everyday ease near Baymeadows Road, I-295, and Southside Boulevard.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>Our leasing team will be in touch soon. In the meantime, picture modern Southside living with a lakeside feel, spacious one-, two-, and three-bedroom layouts, private patios or balconies, and easy everyday comfort at The Vale at Baymeadows.</p>",
  "property_virtualtours_blurb": "<p><strong>Explore The Vale at Baymeadows on your time.</strong> Start with the LoopNet Video and Virtual Tour 3 for a closer look at the community’s lakeside setting, poolside spaces, and relaxed outdoor atmosphere. Then step into the Courtney Meadows apartment walkthrough to get a better feel for the flow of the interiors—from open living areas to kitchen finishes, closet space, and the everyday details that matter in person.</p><p>Use these virtual tours to narrow your search before you compare <a href=\"/floor-plans\">available floor plans</a>, revisit the <a href=\"/gallery\">photo gallery</a>, or choose a time to <a href=\"/schedule-a-tour\">see The Vale at Baymeadows in person</a>. Whether you are across Jacksonville or planning from farther away, you can preview the spaces at your own pace and picture how each view, room, and shared amenity comes together.</p>",
  "property_copyright": "2026 All Rights Reserved. The Vale at Baymeadows",
  "property_seo_title_home": "The Vale at Baymeadows |  Apartments in Jacksonville, FL",
  "property_seo_description_home": "Experience luxury living at The Vale at Baymeadows in Jacksonville! From resort-style amenities to stunning floor plans, your perfect home awaits.",
  "property_seo_title_floorplans": "Floor Plans | Jacksonville, FL Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at The Vale at Baymeadows! Choose from stylish one, two, or three bedroom floor plans in vibrant Jacksonville, FL.",
  "property_seo_title_amenities": "Amenities | Jacksonville, FL Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury at The Vale at Baymeadows! Enjoy top amenities, spacious layouts, and vibrant Jacksonville living near St. John's Town Center.",
  "property_seo_title_gallery": "Gallery | Apartments in Jacksonville, FL",
  "property_seo_description_gallery": "Experience life at The Vale at Baymeadows! From stunning pool views to spacious floor plans, your ideal Jacksonville home awaits. Picture yourself here today!",
  "property_seo_title_virtualtours": "Virtual Tours | The Vale at Baymeadows Apartments",
  "property_seo_description_virtualtours": "Step inside The Vale at Baymeadows in Jacksonville, FL! Experience our stunning one, two, and three-bedroom apartments with a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | The Vale at Baymeadows Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at The Vale at Baymeadows! Use our interactive map to explore stylish apartments, top-notch amenities, and vibrant Jacksonville living.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Jacksonville, FL",
  "property_seo_description_neighborhood": "Uncover local gems at The Vale at Baymeadows in Jacksonville, FL. Dive into vibrant neighborhoods, dining hotspots, and attractions right at your doorstep!",
  "property_seo_title_contact": "Contact Us | The Vale at Baymeadows",
  "property_seo_description_contact": "Contact The Vale at Baymeadows in Jacksonville, FL! Our friendly team is ready to help with questions about our spacious one to three-bedroom homes.",
  "property_seo_title_faqs": "FAQs | Apartments in Jacksonville, FL",
  "property_seo_description_faqs": "Find answers at The Vale at Baymeadows! Explore our FAQs to learn about our beautiful apartments and amenities in Jacksonville, FL.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Jacksonville, FL",
  "property_seo_description_reviews": "Experience The Vale at Baymeadows in Jacksonville, FL: top amenities, scenic views, and spacious floor plans. Hear from our happy residents!",
  "property_seo_title_applynow": "Apply Now | Apartments in Jacksonville, FL",
  "property_seo_description_applynow": "Discover vibrant living at The Vale at Baymeadows in Jacksonville, FL! Stylish 1, 2, or 3-bedroom homes with resort-style amenities await. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | The Vale at Baymeadows",
  "property_seo_description_residentaccess": "Streamline your living experience at The Vale at Baymeadows. Log in to your resident portal for rent payments, maintenance requests, and exclusive updates!",
  "property_seo_title_referafriend": "Refer A Friend | The Vale at Baymeadows",
  "property_seo_description_referafriend": "Refer a friend to The Vale at Baymeadows in sunny Jacksonville, FL, where great friends become neighbors! Join our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Vale at Baymeadows",
  "property_seo_description_scheduletour": "Discover The Vale at Baymeadows in Jacksonville, FL! Schedule your tour today to find your perfect home in a vibrant, modern setting.",
  "property_seo_title_privacy": "Privacy Policy | The Vale at Baymeadows",
  "property_seo_description_privacy": "Stay secure at The Vale at Baymeadows. Your privacy matters to us—read our policy to see how we protect your information in Jacksonville, FL.",
  "property_seo_title_accessibility": "Website Accessibility | The Vale at Baymeadows",
  "property_seo_description_accessibility": "At The Vale at Baymeadows in Jacksonville, FL, we prioritize accessibility and digital inclusion, creating a welcoming home for all.",
  "property_seo_title_sitemap": "Sitemap | The Vale at Baymeadows",
  "property_seo_description_sitemap": "Navigate your way to luxury living at The Vale at Baymeadows in Jacksonville, FL. Uncover our community amenities and find your perfect apartment today!",
  "property_seo_title_thankyou": "Thank You | The Vale at Baymeadows",
  "property_seo_description_thankyou": "Thank you for your interest in The Vale at Baymeadows! Our team will reach out soon to help you discover your new home in Jacksonville, FL.",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791213927420",
  "amenities": [
    {
      "id": "custom_a5d1c9b5-df42-4b80-bf46-bba6ae68ea43",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances *",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_73e22ac5-55fb-4016-b9fd-5720c5136de0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Quartz or Granite Countertops *",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_81615477-382b-4f89-a87c-9bfb0af339cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-In Closet",
      "amount": "false",
      "description": "Generous Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d93480b4-f635-4085-81cb-7599c3a4d78e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Sleek White Cabinetry with Modern Hardware *",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_15ff08f0-fba7-41ae-8624-4c1809dc1582",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000000624",
      "title": "Crown Molding",
      "amount": "0.0000",
      "description": "9-Foot Ceilings with Crown Molding",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2376c900-4135-4d71-8da9-e7287a422e4f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8d40893-855f-4f69-b130-fba5e1a3f0ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000000654",
      "title": "Lake Views",
      "amount": "0.0000",
      "description": "Scenic Lake & Pool Views *",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5459c82c-f26f-423f-8fcc-08e30dbb1e75",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patio or Balcony *",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cea88fd8-dd7a-4733-96c6-8841a515b7cf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000002647",
      "title": "Additional Storage Units",
      "amount": "0.0000",
      "description": "Additional Storage Units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9017de2a-034e-430a-9998-fcb264292025",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000000688",
      "title": "Sundeck",
      "amount": "0.0000",
      "description": "Vacation-Inspired Pool with Sundeck",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cc683035-f4de-43a7-a23b-0dc312dae46e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000000662",
      "title": "Outdoor Kitchen",
      "amount": "0.0000",
      "description": "Outdoor Kitchen & Grilling Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8d62b28a-2f9f-45a6-ba47-ff52cb1ba410",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Large Off-Leash Dog Park",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0163c9cc-2f5e-465e-bcd4-21057fdede60",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000002448",
      "title": "Dog Wash Station",
      "amount": "0.0000",
      "description": "Dedicated Dog Wash Station",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dd2a1771-91fa-4c79-89a8-7cfcaf6a902d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000000610",
      "title": "Car Charging Stations",
      "amount": "0.0000",
      "description": "EV Charging Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_959d3436-4f3d-4853-a040-faf7a6103a08",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000000611",
      "title": "Car Wash",
      "amount": "0.0000",
      "description": "On-Site Car Wash Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8751cc00-6c2f-454e-b973-a3f1ad8ec902",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000002543",
      "title": "Package Reception",
      "amount": "0.0000",
      "description": "Convenient 24/7 Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8c59f646-be06-4736-999a-4dfb7392bd79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2367afe3-dfcb-4b74-8d5d-4ec1ecb233bf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Detached Private Garages",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_300461bf-331c-402f-bf96-fe1a9647dac3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000002482",
      "title": "24 Hour Emergency Maintenance",
      "amount": "0.0000",
      "description": "24 Hour Emergency Maintenance",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f15bf32-3476-4ba1-a337-276d87ce80ba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000002561",
      "title": "RentPlus",
      "amount": "0.0000",
      "description": "Credit Building powered by RentPlus",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0d968f28-d942-4136-a207-b570b52940eb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d72a5aae-8bb2-4488-b727-03b18bbf0d15",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000002563",
      "title": "Spruce",
      "amount": "0.0000",
      "description": "Spruce",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d8922b94-aa4f-492e-9684-598d7f6fc8ea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_a0000bcb-9b6b-4d7d-bc34-6ed635fd8a74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/01a001e5-84d0-75ac-9bba-f934406a2c8c.webp",
      "image_media": {
        "alt_text": "The Vale property lobby with a white reception desk, modern art, and comfortable seating.",
        "public_id": "01a001e5-84d0-75ac-9bba-f934406a2c8c",
        "storage_key": "property/6767906449167307/01a001e5-84d0-75ac-9bba-f934406a2c8c.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Community",
      "description": "Welcome to The Vale! Our spacious lobby features a sleek reception desk, contemporary artwork, and inviting seating areas for residents and guests.",
      "link": "",
      "alt_text": "The Vale property lobby with a white reception desk, modern art, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ae258141-6be8-40a3-9f83-3a3a2c4000df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/01a001e5-856e-779a-b109-9928f10fe5fe.webp",
      "image_media": {
        "alt_text": "Modern living room with a green sofa, pink armchair, and entertainment console.",
        "public_id": "01a001e5-856e-779a-b109-9928f10fe5fe",
        "storage_key": "property/6767906449167307/01a001e5-856e-779a-b109-9928f10fe5fe.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a plush green sofa, a unique pink armchair, and a sleek entertainment console, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Modern living room with a green sofa, pink armchair, and entertainment console.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4c444fcd-4489-40a6-a290-3c59b0b71a77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/01a001e5-80d6-77bb-806d-892c1d301e3e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a breakfast bar.",
        "public_id": "01a001e5-80d6-77bb-806d-892c1d301e3e",
        "storage_key": "property/6767906449167307/01a001e5-80d6-77bb-806d-892c1d301e3e.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen featuring stainless steel appliances, ample cabinet storage, and a sleek breakfast bar perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9751421d-4930-4322-bf4a-fcb0a60ff186",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/01a001e5-76f5-7488-bae8-abc93fba7f06.webp",
      "image_media": {
        "alt_text": "Lobby seating area with modern furniture and abstract wall art.",
        "public_id": "01a001e5-76f5-7488-bae8-abc93fba7f06",
        "storage_key": "property/6767906449167307/01a001e5-76f5-7488-bae8-abc93fba7f06.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Community",
      "description": "Relax and unwind in the beautifully designed lobby, featuring stylish seating and unique decor.",
      "link": "",
      "alt_text": "Lobby seating area with modern furniture and abstract wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6da66f15-b456-4e9c-97a2-305d790ac92c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/01a001e5-76f8-7484-b4c2-308ab0790b24.webp",
      "image_media": {
        "alt_text": "Living room with sofa, chess board and chairs. Kitchen visible in background.",
        "public_id": "01a001e5-76f8-7484-b4c2-308ab0790b24",
        "storage_key": "property/6767906449167307/01a001e5-76f8-7484-b4c2-308ab0790b24.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Stylish living area with modern furnishings, including a plush sofa, decorative chairs, and a chess set. The open-concept design connects to a sleek kitchen.",
      "link": "",
      "alt_text": "Living room with sofa, chess board and chairs. Kitchen visible in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8f62f9ff-4cd4-4937-bc97-80dd49a041ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/01a001e5-779f-7087-99b8-7f5f7cab7f39.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large sink.",
        "public_id": "01a001e5-779f-7087-99b8-7f5f7cab7f39",
        "storage_key": "property/6767906449167307/01a001e5-779f-7087-99b8-7f5f7cab7f39.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample cabinet space, and a deep basin sink, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9a6e966b-7d1b-43ff-9ace-dede15478090",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/01a001e5-770f-736b-92ff-0a5a60f2cc00.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a closet.",
        "public_id": "01a001e5-770f-736b-92ff-0a5a60f2cc00",
        "storage_key": "property/6767906449167307/01a001e5-770f-736b-92ff-0a5a60f2cc00.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed, stylish nightstands with lamps, and a spacious closet. Perfect for relaxation and unwinding.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstands, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_918cce3b-26a4-4c43-81e7-54db023a6c1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/01a001e5-7701-77bc-a934-5968f0700ba9.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and walk-in closet.",
        "public_id": "01a001e5-7701-77bc-a934-5968f0700ba9",
        "storage_key": "property/6767906449167307/01a001e5-7701-77bc-a934-5968f0700ba9.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Bright and modern bathroom featuring a spacious vanity, a private toilet area, and a large walk-in closet with ample shelving.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7f1c0f37-4397-4ed0-913d-7ba3ddfa9b17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/01a001e5-7641-7781-b7bc-079012d0eaa8.webp",
      "image_media": {
        "alt_text": "Screened-in balcony with outdoor dining set, potted plant, and view of residential street.",
        "public_id": "01a001e5-7641-7781-b7bc-079012d0eaa8",
        "storage_key": "property/6767906449167307/01a001e5-7641-7781-b7bc-079012d0eaa8.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening meal on the private, screened-in balcony, perfect for embracing indoor-outdoor living.",
      "link": "",
      "alt_text": "Screened-in balcony with outdoor dining set, potted plant, and view of residential street.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_73c39685-56c4-431a-9578-9f54568a898f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/01a001e5-72e6-7050-958e-36aa9078dde9.webp",
      "image_media": {
        "alt_text": "Open-concept living and kitchen area with a dining nook and view into the bedroom.",
        "public_id": "01a001e5-72e6-7050-958e-36aa9078dde9",
        "storage_key": "property/6767906449167307/01a001e5-72e6-7050-958e-36aa9078dde9.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Experience modern living in this beautifully appointed apartment, featuring an open-concept design that seamlessly connects the living area, dining space, and a sleek, functional kitchen. A glimpse into the tranquil bedroom offers a peaceful retreat.",
      "link": "",
      "alt_text": "Open-concept living and kitchen area with a dining nook and view into the bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_06adf00b-48c9-4f20-8aca-34211d3ec031",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/01a001e5-73ba-73ed-90e2-1bee3d3d2787.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, sink, toilet, and bathtub.",
        "public_id": "01a001e5-73ba-73ed-90e2-1bee3d3d2787",
        "storage_key": "property/6767906449167307/01a001e5-73ba-73ed-90e2-1bee3d3d2787.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Enjoy the spacious and modern bathroom featuring a double vanity, a sleek sink, a toilet, and a bathtub with a shower.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, sink, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d883120a-ae9d-4a10-ad18-94b084d7c6ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/01a001e5-71eb-70ea-9dc9-f162af873365.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with storage shelves above.",
        "public_id": "01a001e5-71eb-70ea-9dc9-f162af873365",
        "storage_key": "property/6767906449167307/01a001e5-71eb-70ea-9dc9-f162af873365.webp",
        "width": 1086,
        "height": 1448
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs, with overhead shelving for additional storage.",
      "link": "",
      "alt_text": "In-unit washer and dryer with storage shelves above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a5e16f0b-de82-462e-9435-ed74825ff90f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/01a001b3-e783-746d-b4d1-8995b2ba5cca.webp",
      "image_media": {
        "alt_text": "Lobby seating area with plush chairs, modern coffee tables, and a decorative wall.",
        "public_id": "01a001b3-e783-746d-b4d1-8995b2ba5cca",
        "storage_key": "property/6767906449167307/01a001b3-e783-746d-b4d1-8995b2ba5cca.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby, featuring comfortable seating and modern decor.",
      "link": "",
      "alt_text": "Lobby seating area with plush chairs, modern coffee tables, and a decorative wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5eb31555-30e1-4086-a640-ae6a57436e39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019e8a09-253d-761e-937b-2177667d1ff5.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a pool and lake with a fountain.",
        "public_id": "019e8a09-253d-761e-937b-2177667d1ff5",
        "storage_key": "property/6767906449167307/019e8a09-253d-761e-937b-2177667d1ff5.webp",
        "width": 1800,
        "height": 980
      },
      "title": "Community",
      "description": "Spacious apartment complex featuring a sparkling swimming pool, serene lake with a fountain, and lush green landscaping.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings surrounding a pool and lake with a fountain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9d9cab3d-21ef-4748-b106-36ee2ad64fac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019e8a09-220a-71c9-b068-47b65d714fc8.webp",
      "image_media": {
        "alt_text": "Row of attached garages with green doors and beige exteriors.",
        "public_id": "019e8a09-220a-71c9-b068-47b65d714fc8",
        "storage_key": "property/6767906449167307/019e8a09-220a-71c9-b068-47b65d714fc8.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Secure attached garages available for residents, offering convenient and safe parking for vehicles.",
      "link": "",
      "alt_text": "Row of attached garages with green doors and beige exteriors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a15a3df9-2ec8-4883-9c43-1f683ac9c4cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019e8a09-1d63-761a-b6d2-ed8b8893f931.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment, benches, and apartment buildings in the background.",
        "public_id": "019e8a09-1d63-761a-b6d2-ed8b8893f931",
        "storage_key": "property/6767906449167307/019e8a09-1d63-761a-b6d2-ed8b8893f931.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with agility obstacles for your furry friends and comfortable seating for you. A great space for pets to play and socialize.",
      "link": "",
      "alt_text": "Dog park with agility equipment, benches, and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1810ff4d-6ae7-49e6-b3d1-7b547c7176ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019e8a09-1e94-71ee-b836-648421bc9b7b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas next to a building at dusk.",
        "public_id": "019e8a09-1e94-71ee-b836-648421bc9b7b",
        "storage_key": "property/6767906449167307/019e8a09-1e94-71ee-b836-648421bc9b7b.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, perfect for relaxing and unwinding after a long day. Lounge chairs and umbrellas provide ultimate comfort.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas next to a building at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6c718fd0-4033-4397-959d-7b6e66c33f8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019e8a09-1ae3-7398-9af1-a28e128d8724.webp",
      "image_media": {
        "alt_text": "Sparkling swimming pool with lounge chairs and umbrellas under palm trees.",
        "public_id": "019e8a09-1ae3-7398-9af1-a28e128d8724",
        "storage_key": "property/6767906449167307/019e8a09-1ae3-7398-9af1-a28e128d8724.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by lush landscaping and comfortable seating. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Sparkling swimming pool with lounge chairs and umbrellas under palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f4f147c1-a71e-48f3-bf3c-803c035601d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019e8a09-1cef-71e0-b28c-c913b94891bb.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a canopy and cushions next to a fountain.",
        "public_id": "019e8a09-1cef-71e0-b28c-c913b94891bb",
        "storage_key": "property/6767906449167307/019e8a09-1cef-71e0-b28c-c913b94891bb.webp",
        "width": 825,
        "height": 500
      },
      "title": "Community",
      "description": "Relax and unwind in our beautiful outdoor seating area, complete with a covered canopy and comfortable cushions. Enjoy the soothing sounds of the nearby fountain.",
      "link": "",
      "alt_text": "Outdoor seating area with a canopy and cushions next to a fountain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fb7a6dda-bd21-4931-b0bc-b2f6b969b7a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019e8a09-1a3e-733d-a145-f29b9ec6f755.webp",
      "image_media": {
        "alt_text": "Apartment buildings reflecting in a pond at dusk",
        "public_id": "019e8a09-1a3e-733d-a145-f29b9ec6f755",
        "storage_key": "property/6767906449167307/019e8a09-1a3e-733d-a145-f29b9ec6f755.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Experience serene living with beautiful apartment buildings set against a tranquil pond at twilight.",
      "link": "",
      "alt_text": "Apartment buildings reflecting in a pond at dusk",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ce65d553-8b76-4087-b4cf-194903cf3146",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019e8a09-1a96-759b-924f-bf8246e42b66.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and weight machines.",
        "public_id": "019e8a09-1a96-759b-924f-bf8246e42b66",
        "storage_key": "property/6767906449167307/019e8a09-1a96-759b-924f-bf8246e42b66.webp",
        "width": 825,
        "height": 500
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines and free weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_10c6984b-1c94-4167-8f9f-5d548cb817b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Topgolf Jacksonville",
      "poi_type": "Restaurants",
      "poi_address": "10531 Brightman Blvd, Jacksonville, FL 32246, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun golfing experience with a variety of games, and tasty snacks like mac & cheese bites and wings. They highlight the lively and energetic atmosphere, making it a great place for a casual outing with friends or family, and especially fun for birthday parties. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-4b92-72cb-862a-346346055beb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-4b92-72cb-862a-346346055beb",
        "storage_key": "property/6767906449167307/019d02f7-4b92-72cb-862a-346346055beb.webp",
        "width": 1000,
        "height": 720
      },
      "poi_business_url": "https://topgolf.com/us/jacksonville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=551425716930125462&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-jacksonville",
      "poi_latitude": "30.2632674",
      "poi_longitude": "-81.5205175",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-328-2002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9696-756b-95fc-7c2fc840a336.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9696-756b-95fc-7c2fc840a336",
        "storage_key": "property/6767906449167307/019d02f7-9696-756b-95fc-7c2fc840a336.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPUWBGFK15YgRlp6imcQOpwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7473217e-1baf-4d5c-93c8-e024c64e5852",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "10260 Mid Town Pkwy, Jacksonville, FL 32246, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "Diners say this restaurant offers a wide variety of choices, including delicious pasta, burgers, and cheesecake. They also highlight the friendly and attentive service, generous portions, and lively atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da0-7d7f-7389-b8c2-942729d18f1b.webp",
      "poi_featured_image_media": {
        "alt_text": "The Cheesecake Factory restaurant exterior at dusk.",
        "public_id": "019d6da0-7d7f-7389-b8c2-942729d18f1b",
        "storage_key": "property/6767906449167307/019d6da0-7d7f-7389-b8c2-942729d18f1b.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/fl/jacksonville-90.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=13903034274464388603&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "30.2576664",
      "poi_longitude": "-81.52685679999999",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-998-9511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9696-756b-95fc-7c2fc840a336.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9696-756b-95fc-7c2fc840a336",
        "storage_key": "property/6767906449167307/019d02f7-9696-756b-95fc-7c2fc840a336.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi4Su31m15YgR-9WH3QKA8cA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_78ddfcc8-3548-4622-a062-3bbdb53e130e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Dave & Buster's Jacksonville",
      "poi_type": "Restaurants",
      "poi_address": "7025 Salisbury Rd, Jacksonville, FL 32256, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "People say this restaurant offers delicious burgers, a wide selection of drinks, and a fun-filled arcade with games for all ages. They also highlight the friendly and helpful staff, the lively atmosphere, and the great value of the eat and play combos.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da0-c42e-77c1-b065-58ad670aa0f3.webp",
      "poi_featured_image_media": {
        "alt_text": "People cheering while watching football games on multiple screens in a bar.",
        "public_id": "019d6da0-c42e-77c1-b065-58ad670aa0f3",
        "storage_key": "property/6767906449167307/019d6da0-c42e-77c1-b065-58ad670aa0f3.webp",
        "width": 3072,
        "height": 2074
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/jacksonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=11215967955750459618&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dave--busters-jacksonville",
      "poi_latitude": "30.2450525",
      "poi_longitude": "-81.58762709999999",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-296-1525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9696-756b-95fc-7c2fc840a336.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9696-756b-95fc-7c2fc840a336",
        "storage_key": "property/6767906449167307/019d02f7-9696-756b-95fc-7c2fc840a336.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhSxq9hHK5YgR4pirVm4fp5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f715a094-196a-4657-9c8f-dda6960d4e0a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "4578 Tropea Wy, Jacksonville, FL 32246, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves great steaks, ribs, and burgers. They also highlight the generous portions, delicious rolls with cinnamon butter, and the welcoming, lively atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da0-7d80-72c1-b108-ed10b10a314a.webp",
      "poi_featured_image_media": {
        "alt_text": "Texas Roadhouse restaurant exterior at night with a visible sign and lights.",
        "public_id": "019d6da0-7d80-72c1-b108-ed10b10a314a",
        "storage_key": "property/6767906449167307/019d6da0-7d80-72c1-b108-ed10b10a314a.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/florida/jacksonville?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=18141132104530571548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "30.2612857",
      "poi_longitude": "-81.53051669999999",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-641-6350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9696-756b-95fc-7c2fc840a336.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9696-756b-95fc-7c2fc840a336",
        "storage_key": "property/6767906449167307/019d02f7-9696-756b-95fc-7c2fc840a336.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh0xoplu15YgRHLH6gYg_wvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_1fa624f4-a790-4c0b-b677-ff13804cbe27",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Main Event Jacksonville",
      "poi_type": "Restaurants",
      "poi_address": "10370 Philips Hwy, Jacksonville, FL 32256, USA",
      "poi_short_description": "Games and a bar featuring American eats like wings and burgers.",
      "poi_long_description": "Visitors say this family entertainment center offers bowling, laser tag, an arcade, and a bar with drinks. They also highlight the friendly staff and fun atmosphere.\n\nSome reviews mention there can be long wait times for service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da0-7bc1-71ee-a608-a07c1103bddd.webp",
      "poi_featured_image_media": {
        "alt_text": "Bowling alley with racks of bowling balls in the foreground and lanes in the background.",
        "public_id": "019d6da0-7bc1-71ee-a608-a07c1103bddd",
        "storage_key": "property/6767906449167307/019d6da0-7bc1-71ee-a608-a07c1103bddd.webp",
        "width": 500,
        "height": 280
      },
      "poi_business_url": "http://www.mainevent.com/locations/florida/jacksonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=16907461409632428594&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-jacksonville",
      "poi_latitude": "30.1802857",
      "poi_longitude": "-81.55505629999999",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-260-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9696-756b-95fc-7c2fc840a336.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9696-756b-95fc-7c2fc840a336",
        "storage_key": "property/6767906449167307/019d02f7-9696-756b-95fc-7c2fc840a336.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB5PzpHbL5YgRMiLEjpJeo-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b1ed8d05-2bdb-4ee4-94c8-b2c08dfa80f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "The Avenues",
      "poi_type": "Shopping & Retail",
      "poi_address": "10300 Southside Blvd, Jacksonville, FL 32256, USA",
      "poi_short_description": "Bright, modern mall features familiar big-box stores, clothing boutiques, restaurants & a wine bar.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including popular brands and unique shops, and a great food court with diverse options. They also highlight the clean and bright atmosphere, and the fun, nostalgic vibe.\n\nSome reviews mention the mall can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d92c2-49e4-75f8-842b-d199879c86ac.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of The Avenues shopping center with palm trees and cars in the parking lot.",
        "public_id": "019d92c2-49e4-75f8-842b-d199879c86ac",
        "storage_key": "property/6767906449167307/019d92c2-49e4-75f8-842b-d199879c86ac.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://www.simon.com/mall/the-avenues",
      "poi_directions_map_url": "https://maps.google.com/?cid=10488048585255883970&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-avenues",
      "poi_latitude": "30.184439",
      "poi_longitude": "-81.554024",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-363-3060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9bdc-71cb-a894-614c2a267064.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9bdc-71cb-a894-614c2a267064",
        "storage_key": "property/6767906449167307/019d02f7-9bdc-71cb-a894-614c2a267064.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjQlbVnPL5YgRwhQ3x54IjZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_0c011758-bcd4-4388-a8ff-373b0bb75a13",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "St. Johns Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "4663 River City Dr, Jacksonville, FL 32246, USA",
      "poi_short_description": "Outdoor mall with known fashion, home goods & electronics brands, sit-down dining & quick snacks.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including designer brands and everyday favorites, and plenty of dining options. They highlight the outdoor setup is clean, spacious, and easy to walk around, making it a great spot for both shopping and casual outings. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da0-7bb5-76ba-a316-b4a6c5449957.webp",
      "poi_featured_image_media": {
        "alt_text": "Street view of luxury retail stores, including Louis Vuitton and Tiffany & Co., with palm trees and shoppers.",
        "public_id": "019d6da0-7bb5-76ba-a316-b4a6c5449957",
        "storage_key": "property/6767906449167307/019d6da0-7bb5-76ba-a316-b4a6c5449957.webp",
        "width": 952,
        "height": 634
      },
      "poi_business_url": "https://www.simon.com/mall/st-johns-town-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=18063775443598808474&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-johns-town-center",
      "poi_latitude": "30.2568706",
      "poi_longitude": "-81.5253244",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-998-7156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9bdc-71cb-a894-614c2a267064.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9bdc-71cb-a894-614c2a267064",
        "storage_key": "property/6767906449167307/019d02f7-9bdc-71cb-a894-614c2a267064.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFX_HOVe15YgRmpUhWg9sr_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b688fb84-1204-4eaf-878d-8e03e6579b79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "7801 Gate Pkwy, Jacksonville, FL 32256, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "People say this furniture store offers a wide variety of home goods, furniture, and kitchenware. They also highlight the affordable prices, fun and inspiring atmosphere, and helpful staff.\n\nOther reviews mention the layout can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da0-84fb-7165-9980-beabb89223e0.webp",
      "poi_featured_image_media": {
        "alt_text": "IKEA Home Furnishings store exterior with large blue building and parking lot.",
        "public_id": "019d6da0-84fb-7165-9980-beabb89223e0",
        "storage_key": "property/6767906449167307/019d6da0-84fb-7165-9980-beabb89223e0.webp",
        "width": 3072,
        "height": 1392
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/jacksonville/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=jacksonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=1842684368552300310&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "30.2373851",
      "poi_longitude": "-81.5165329",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9bdc-71cb-a894-614c2a267064.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9bdc-71cb-a894-614c2a267064",
        "storage_key": "property/6767906449167307/019d02f7-9bdc-71cb-a894-614c2a267064.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVQQCMLPK5YgRFo-5lKuHkhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_4ab7d9fa-0045-485c-b1bb-5fb20619eded",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "RD International Market And Food Court",
      "poi_type": "Shopping & Retail",
      "poi_address": "7534 Beach Blvd, Jacksonville, FL 32216, USA",
      "poi_short_description": "Grocery store featuring an international array of products, plus a bakery and seafood market.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of international products, especially fresh vegetables, spices, and ready-to-eat meals, as well as a food court and fish market. They highlight the clean and well-organized store, and the friendly and helpful staff. They also like the unique and rare items that can't be found in regular supermarkets.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-efca-72a8-9c6d-41e0bde86a41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-efca-72a8-9c6d-41e0bde86a41",
        "storage_key": "property/6767906449167307/019d02f7-efca-72a8-9c6d-41e0bde86a41.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "http://www.rdinternationalmarketjax.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14288681607695045651&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rd-international-market-and-food-court",
      "poi_latitude": "30.2871073",
      "poi_longitude": "-81.58029259999999",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-666-2221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9b8e-708f-b69d-a4279bcc0d4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9b8e-708f-b69d-a4279bcc0d4d",
        "storage_key": "property/6767906449167307/019d02f7-9b8e-708f-b69d-a4279bcc0d4d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-9QYJ4i15YgRExRSrzeYS8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_589bcd97-6abf-4df8-96ae-e78a289cb2a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "9021 Southside Blvd, Jacksonville, FL 32256, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide selection of tools, equipment, and materials for various projects. They also highlight the helpful and friendly staff, and the convenient parking.\n\nOther reviews mention the store can be disorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-f075-749d-b2a2-36f743a8d7ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-f075-749d-b2a2-36f743a8d7ce",
        "storage_key": "property/6767906449167307/019d02f7-f075-749d-b2a2-36f743a8d7ce.webp",
        "width": 1242,
        "height": 698
      },
      "poi_business_url": "https://www.homedepot.com/l/Southside/FL/Jacksonville/32256/226?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17628400972100505727&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "30.1958185",
      "poi_longitude": "-81.549055",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-464-0046",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9bdc-71cb-a894-614c2a267064.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9bdc-71cb-a894-614c2a267064",
        "storage_key": "property/6767906449167307/019d02f7-9bdc-71cb-a894-614c2a267064.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJK8FZwQ_L5YgRf5Az7EippPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_c7566095-4692-4eb8-bc71-c0431d11a8ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "University of North Florida (UNF)",
      "poi_type": "Education",
      "poi_address": "1 UNF Dr., Jacksonville, FL 32224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-87e8-736b-935c-a89e97eae8da.webp",
      "poi_featured_image_media": {
        "alt_text": "Boardwalk along a lake with a modern brick building in the background.",
        "public_id": "019d02f7-87e8-736b-935c-a89e97eae8da",
        "storage_key": "property/6767906449167307/019d02f7-87e8-736b-935c-a89e97eae8da.webp",
        "width": 1728,
        "height": 3072
      },
      "poi_business_url": "http://www.unf.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18226157899370904914&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-north-florida-unf",
      "poi_latitude": "30.2661204",
      "poi_longitude": "-81.50723140000001",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 904-620-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9bd9-7198-bcc7-500edbc31ab7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9bd9-7198-bcc7-500edbc31ab7",
        "storage_key": "property/6767906449167307/019d02f7-9bd9-7198-bcc7-500edbc31ab7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU2DTHbRK5IgRUr0uDAtS8Pw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4d9f3ab1-f014-4634-8c4c-0a548dda6582",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "FSCJ Deerwood Center",
      "poi_type": "Education",
      "poi_address": "9911 Old Baymeadows Rd, Jacksonville, FL 32256, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da0-9429-71c9-b6fd-9bb731b3915e.webp",
      "poi_featured_image_media": {
        "alt_text": "Building exterior with colorful sunset sky",
        "public_id": "019d6da0-9429-71c9-b6fd-9bb731b3915e",
        "storage_key": "property/6767906449167307/019d6da0-9429-71c9-b6fd-9bb731b3915e.webp",
        "width": 2329,
        "height": 3072
      },
      "poi_business_url": "https://www.fscj.edu/campuses/deerwood-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=15619238271498864099&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fscj-deerwood-center",
      "poi_latitude": "30.22186629999999",
      "poi_longitude": "-81.5537294",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-646-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9bd9-7198-bcc7-500edbc31ab7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9bd9-7198-bcc7-500edbc31ab7",
        "storage_key": "property/6767906449167307/019d02f7-9bd9-7198-bcc7-500edbc31ab7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq6pqsfDK5YgR40XgInSuwtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c3a68b98-20c6-401b-9f60-74027665cd5b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Florida State College at Jacksonville South Campus",
      "poi_type": "Education",
      "poi_address": "11901 Beach Blvd, Jacksonville, FL 32246, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da0-9a1a-761c-a95a-f751a8f825cd.webp",
      "poi_featured_image_media": {
        "alt_text": "Concrete walkway with outdoor seating area and architectural elements",
        "public_id": "019d6da0-9a1a-761c-a95a-f751a8f825cd",
        "storage_key": "property/6767906449167307/019d6da0-9a1a-761c-a95a-f751a8f825cd.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.fscj.edu/campuses/south-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=16948186818882788353&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "florida-state-college-at-jacksonville-south-campus",
      "poi_latitude": "30.2926412",
      "poi_longitude": "-81.508229",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-646-2111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9bd9-7198-bcc7-500edbc31ab7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9bd9-7198-bcc7-500edbc31ab7",
        "storage_key": "property/6767906449167307/019d02f7-9bd9-7198-bcc7-500edbc31ab7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQYwnStFK5IgRAVx3zh0ONOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_fa1e9377-dbdd-4a2f-9f16-41851cb243a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Thomas G. Carpenter Library",
      "poi_type": "Education",
      "poi_address": "1 UNF Dr., Jacksonville, FL 32224, USA",
      "poi_short_description": "Modern library at the University of North Florida, featuring 4 floors, each with a different purpose.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-f568-77f8-983b-445a153ab78e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-f568-77f8-983b-445a153ab78e",
        "storage_key": "property/6767906449167307/019d02f7-f568-77f8-983b-445a153ab78e.webp",
        "width": 1280,
        "height": 863
      },
      "poi_business_url": "http://www.unf.edu/library/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3165375648636711158&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thomas-g-carpenter-library",
      "poi_latitude": "30.26924039999999",
      "poi_longitude": "-81.5084268",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 904-620-2615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-a9fe-71b6-80a8-a4b25dc01d75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-a9fe-71b6-80a8-a4b25dc01d75",
        "storage_key": "property/6767906449167307/019d02f7-a9fe-71b6-80a8-a4b25dc01d75.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU2DTHbRK5IgR9rCprWGs7Ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_6a1bda99-ecd8-49b6-9d33-c1cab9bdcbce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Southeast Regional Library",
      "poi_type": "Education",
      "poi_address": "10599 Deerwood Park Blvd, Jacksonville, FL 32256, USA",
      "poi_short_description": "Family-friendly branch of the city's broader system offering books and computers plus an adult literacy program and activities for kids and teens.",
      "poi_long_description": "People say this public library offers an extensive selection of books, including a children's section, and provides access to computers, printing services, and meeting rooms. They highlight the clean, organized, and well-maintained facility, as well as the peaceful atmosphere with lake views. They also like the helpful, patient, and respectful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da0-ade0-73cd-b5e4-d8353de8e090.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a library with bookshelves, tables, and a welcome sign in multiple languages.",
        "public_id": "019d6da0-ade0-73cd-b5e4-d8353de8e090",
        "storage_key": "property/6767906449167307/019d6da0-ade0-73cd-b5e4-d8353de8e090.webp",
        "width": 3072,
        "height": 2030
      },
      "poi_business_url": "https://jaxpubliclibrary.org/locations/southeast-regional",
      "poi_directions_map_url": "https://maps.google.com/?cid=2249056110444859971&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southeast-regional-library",
      "poi_latitude": "30.2489074",
      "poi_longitude": "-81.5394975",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 904-255-2665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9bd9-7198-bcc7-500edbc31ab7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9bd9-7198-bcc7-500edbc31ab7",
        "storage_key": "property/6767906449167307/019d02f7-9bd9-7198-bcc7-500edbc31ab7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3QfMMp_K5YgRQ9L8zp1ANh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_da6f1b6d-4246-466a-ab44-d7368461f49e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "9950 Southside Blvd, Jacksonville, FL 32256, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities for kids of all ages, including go-karts, trampolines, and a ropes course. They also highlight the friendly and helpful staff, and the clean environment.\n\nOther reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-f626-717b-a723-6d254a34707f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-f626-717b-a723-6d254a34707f",
        "storage_key": "property/6767906449167307/019d02f7-f626-717b-a723-6d254a34707f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/florida-south-jacksonville/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=6417289696751601289&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "30.1895802",
      "poi_longitude": "-81.5541913",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-712-4457",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9b87-76d3-a516-58e458a8f737",
        "storage_key": "property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE8DBkj7L5YgRiUanm_rKDlk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_6f389e24-8a1a-4bc3-8fa2-bbd7999fd999",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "UNF Arena",
      "poi_type": "Entertainment",
      "poi_address": "11852 UNF Dr., Jacksonville, FL 32224, USA",
      "poi_short_description": "Basketball & volleyball facility with 5,800 seats for Ospreys games, plus racquetball courts.",
      "poi_long_description": "People say this arena is a great venue for graduations, sporting events, and competitions. They highlight the spacious seating, convenient parking, and efficient shuttle service. They also like the well-lit and clean facilities, and the energetic atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da0-aeb2-75fe-8712-50ca8d6d0ee3.webp",
      "poi_featured_image_media": {
        "alt_text": "North Florida Ospreys basketball arena with seating and court.",
        "public_id": "019d6da0-aeb2-75fe-8712-50ca8d6d0ee3",
        "storage_key": "property/6767906449167307/019d6da0-aeb2-75fe-8712-50ca8d6d0ee3.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.unfospreys.com/sports/2007/11/14/facilitiesarena.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16020846551405442437&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "unf-arena",
      "poi_latitude": "30.2734356",
      "poi_longitude": "-81.5079346",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 904-620-2999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9b87-76d3-a516-58e458a8f737",
        "storage_key": "property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJycvgRbZK5IgRhTWQcQ57Vd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_4d719f52-074f-4049-aae9-7898d406caad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Hodges Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1 S U N F Dr, Jacksonville, FL 32224, USA",
      "poi_short_description": "Stadium hosting football games and track and field events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da0-d2bc-751f-bd63-6016d8c1e427.webp",
      "poi_featured_image_media": {
        "alt_text": "Soccer stadium with seating and a soccer field.",
        "public_id": "019d6da0-d2bc-751f-bd63-6016d8c1e427",
        "storage_key": "property/6767906449167307/019d6da0-d2bc-751f-bd63-6016d8c1e427.webp",
        "width": 3072,
        "height": 2313
      },
      "poi_business_url": "http://www.unfospreys.com/sports/2008/9/19/HodgesStadium.aspx?",
      "poi_directions_map_url": "https://maps.google.com/?cid=3942838748672279182&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hodges-stadium",
      "poi_latitude": "30.2750503",
      "poi_longitude": "-81.51167149999999",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-620-2559",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f8-23c1-749e-a480-3fa64b9f3593.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f8-23c1-749e-a480-3fa64b9f3593",
        "storage_key": "property/6767906449167307/019d02f8-23c1-749e-a480-3fa64b9f3593.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgWyfi7VK5IgRjsJBrfPGtzY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_459a2108-21e2-4cc4-a1d0-dd4b3a9813a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Jacksonville's \"Hands On\" Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "8580 Beach Blvd, Jacksonville, FL 32216, USA",
      "poi_short_description": "Interactive & hands-on exhibits including a castle, grocery store & other kid-friendly play areas.",
      "poi_long_description": "Visitors say this children's museum offers a variety of play areas, including a dedicated zone for infants and toddlers, a firefighter station, and a grocery store, keeping kids entertained for hours. They also highlight the friendly and helpful staff who work hard to keep the facility clean, and the affordable entry price.\n\nSome reviews mention the museum can be in need of maintenance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da0-cae4-77f1-b430-670fc310f40a.webp",
      "poi_featured_image_media": {
        "alt_text": "Winn Dixie grocery store aisle with checkout counter and signs.",
        "public_id": "019d6da0-cae4-77f1-b430-670fc310f40a",
        "storage_key": "property/6767906449167307/019d6da0-cae4-77f1-b430-670fc310f40a.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://handsonchildrensmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12354040324284608301&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jacksonvilles-hands-on-childrens-museum",
      "poi_latitude": "30.287004",
      "poi_longitude": "-81.5679835",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-642-2688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-a06a-72c9-9e6f-ff5aabd758d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-a06a-72c9-9e6f-ff5aabd758d1",
        "storage_key": "property/6767906449167307/019d02f7-a06a-72c9-9e6f-ff5aabd758d1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6egK96S15YgRLe_VbThecqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_bb47f865-4162-4298-9fb2-3abd41738b12",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "The Brumos Collection",
      "poi_type": "Entertainment",
      "poi_address": "5159 San Pablo Rd S, Jacksonville, FL 32224, USA",
      "poi_short_description": "Museum for vintage vehicles, including several Porsche models and cars from various eras, as well as interactive displays.",
      "poi_long_description": "People say this museum offers a fantastic collection of rare and historic cars, including American muscle, Porsche, Bugatti, and Alfa Romeo, with detailed information and galleries for each vehicle. They highlight the affordable ticket prices, the clean and well-maintained facility, and the opportunity to see the cars up close and even look inside. They also like the knowledgeable, friendly, and passionate staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-fd36-7179-80cf-f3dfb98abdeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-fd36-7179-80cf-f3dfb98abdeb",
        "storage_key": "property/6767906449167307/019d02f7-fd36-7179-80cf-f3dfb98abdeb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://thebrumoscollection.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17693108311812567784&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-brumos-collection",
      "poi_latitude": "30.2515144",
      "poi_longitude": "-81.43504329999999",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 5 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-373-0375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-a06a-72c9-9e6f-ff5aabd758d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-a06a-72c9-9e6f-ff5aabd758d1",
        "storage_key": "property/6767906449167307/019d02f7-a06a-72c9-9e6f-ff5aabd758d1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJvWM9AwpL5IgR6HIZekSMivU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_960712d3-fb86-4fc8-8e78-9ec2616dc7c8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Brooks Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "10423 Centurion Pkwy N, Jacksonville, FL 32256, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center offers a wide range of amenities, including a pool, sauna, and KidZone, and a strong selection of equipment. They also highlight the reasonable membership price, the clean and calm atmosphere, and the friendly and welcoming staff.\n\nOther reviews mention the classes can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d7918-6796-7059-aded-95548aa36832.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-6796-7059-aded-95548aa36832",
        "storage_key": "property/6767906449167307/019d7918-6796-7059-aded-95548aa36832.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://fcymca.org/locations/brooks-family-ymca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2198302550815666116&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brooks-family-ymca",
      "poi_latitude": "30.2488497",
      "poi_longitude": "-81.5447014",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-854-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9b87-76d3-a516-58e458a8f737",
        "storage_key": "property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_eFDRJDK5YgRxO8z2oXwgR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_2fa21825-2014-4cec-bc71-55f6fd9e0f09",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10915 Baymeadows Rd STE 126, Jacksonville, FL 32256, USA",
      "poi_short_description": "Spacious gym featuring classes, tanning, basketball courts and free weights.",
      "poi_long_description": "People say this fitness center offers a wide variety of equipment and amenities, including a basketball court, sauna, and free fitness classes. They also highlight the clean facilities, friendly and attentive staff, and fair membership prices.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f8-01e3-7306-b68b-7f4d2b54667d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f8-01e3-7306-b68b-7f4d2b54667d",
        "storage_key": "property/6767906449167307/019d02f8-01e3-7306-b68b-7f4d2b54667d.webp",
        "width": 1022,
        "height": 575
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/fl/point-meadows/",
      "poi_directions_map_url": "https://maps.google.com/?cid=792548891008641014&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "30.2171883",
      "poi_longitude": "-81.51814279999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 904-371-4550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9b87-76d3-a516-58e458a8f737",
        "storage_key": "property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ452nuCbL5YgR9iezawSz_wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_591ae2cd-e711-4b47-aa66-4a3bdf20e364",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8661 Old Kings Rd S, Jacksonville, FL 32217, USA",
      "poi_short_description": "Chain offering memberships to access equipment, such as treadmills, in an inclusive space.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and a circuit training setup. They highlight the clean facilities, ample parking, and friendly staff. They also like the moderate foot traffic and comfortable atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-636a-7133-9539-b58a384814c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-636a-7133-9539-b58a384814c5",
        "storage_key": "property/6767906449167307/019d02f7-636a-7133-9539-b58a384814c5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/jacksonville-baymeadows-fl?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2396579732291321868&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "30.2227516",
      "poi_longitude": "-81.59150819999999",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 904-443-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9b87-76d3-a516-58e458a8f737",
        "storage_key": "property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo1FYnnS75YgRDAAgo5FcQiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8067dfef-18aa-4750-9ed8-c4afe19f4911",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Nails.com",
      "poi_type": "Health and Wellness",
      "poi_address": "12192 Beach Blvd #11, Jacksonville, FL 32246, USA",
      "poi_short_description": "Relaxed nail salon providing treatments for hands, feet and eyelashes, plus massages, waxing and hair removal.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f8-0a94-76ea-a027-49829e0809ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f8-0a94-76ea-a027-49829e0809ec",
        "storage_key": "property/6767906449167307/019d02f8-0a94-76ea-a027-49829e0809ec.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://nailcomjacksonville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17112203055492025574&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nailscom",
      "poi_latitude": "30.2865294",
      "poi_longitude": "-81.4960722",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 904-415-9066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9b87-76d3-a516-58e458a8f737",
        "storage_key": "property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7cQaw9xK5IgR5sz0vgPCeu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_ae26032b-b101-4a00-9c42-1009834909ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "TNT Gymnastics and Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2683 St Johns Bluff Rd S Suite 107, Jacksonville, FL 32246, USA",
      "poi_short_description": "Kid-friendly gymnastics center offering recreational lessons and camps.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f8-0b35-719e-95bf-2e8dd92036ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f8-0b35-719e-95bf-2e8dd92036ae",
        "storage_key": "property/6767906449167307/019d02f8-0b35-719e-95bf-2e8dd92036ae.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "http://www.tntgymfit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11569429632710021089&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tnt-gymnastics-and-fitness",
      "poi_latitude": "30.29779199999999",
      "poi_longitude": "-81.5253249",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 904-998-8681",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9bd9-7198-bcc7-500edbc31ab7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9bd9-7198-bcc7-500edbc31ab7",
        "storage_key": "property/6767906449167307/019d02f7-9bd9-7198-bcc7-500edbc31ab7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcR0pIyi15YgR4Q-PF_TejqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5f3f1dff-fe6a-41ac-a960-3f160a2b5eba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "North Florida Gymnastics & Cheerleading",
      "poi_type": "Health and Wellness",
      "poi_address": "11653 Central Pkwy #212, Jacksonville, FL 32224, USA",
      "poi_short_description": "Gymnastics center offering a recreational program, competitive teams, and a summer camp.",
      "poi_long_description": "People say this gymnastics center offers a structured summer camp with a mix of gymnastics skills, organized games, crafts, and snacks. They highlight the well-planned field trips, kid-friendly lunch options, and minimal screen time. They also like the friendly and helpful staff who greet children by name.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da1-0702-75f7-9273-2fae421dc144.webp",
      "poi_featured_image_media": {
        "alt_text": "Gymnastics training facility with balance beams and foam pit.",
        "public_id": "019d6da1-0702-75f7-9273-2fae421dc144",
        "storage_key": "property/6767906449167307/019d6da1-0702-75f7-9273-2fae421dc144.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "http://www.nfgymcheer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14989815583710237512&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-florida-gymnastics--cheerleading",
      "poi_latitude": "30.2824523",
      "poi_longitude": "-81.51702039999999",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-221-5544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9bd9-7198-bcc7-500edbc31ab7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9bd9-7198-bcc7-500edbc31ab7",
        "storage_key": "property/6767906449167307/019d02f7-9bd9-7198-bcc7-500edbc31ab7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmwZGuJ9L5IgRSNOpm9qFBtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_de4de32f-c93d-4b5f-8c40-8645e5492b9f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Mayo Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "4500 San Pablo Rd S, Jacksonville, FL 32224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-89b7-7628-a749-69b6e8f4d11f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-89b7-7628-a749-69b6e8f4d11f",
        "storage_key": "property/6767906449167307/019d02f7-89b7-7628-a749-69b6e8f4d11f.webp",
        "width": 929,
        "height": 523
      },
      "poi_business_url": "http://www.mayoclinic.org/patient-visitor-guide/florida/campus-buildings-maps/mayo-building-hospital?mc_id=us&utm_source=yext&utm_medium=l&utm_content=feature&utm_campaign=mayoclinic&geo=national&placementsite=enterprise&invsrc=other&cauid=102372&y_source=1_MzkxODQ2OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2898705910926404099&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mayo-clinic",
      "poi_latitude": "30.2640897",
      "poi_longitude": "-81.4409507",
      "poi_miles_from_property": "12.8",
      "poi_walking_minutes": "4 hours 43 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-953-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-a1a0-71ba-a1df-74b25a69a4a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-a1a0-71ba-a1df-74b25a69a4a4",
        "storage_key": "property/6767906449167307/019d02f7-a1a0-71ba-a1df-74b25a69a4a4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJk5xKnQ3K5YgRA-oXAatFOig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_34b95bea-de88-4e36-9a74-a53c6e645d73",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Mayo Clinic Mangurian Building",
      "poi_type": "Health and Wellness",
      "poi_address": "4500 Mellish Dr, Jacksonville, FL 32224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f8-0fa1-76ed-bfe9-1cafb967b6ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f8-0fa1-76ed-bfe9-1cafb967b6ca",
        "storage_key": "property/6767906449167307/019d02f8-0fa1-76ed-bfe9-1cafb967b6ca.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.mayoclinic.org/patient-visitor-guide/florida/campus-buildings-maps/mangurian-building",
      "poi_directions_map_url": "https://maps.google.com/?cid=8525248674857159383&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mayo-clinic-mangurian-building",
      "poi_latitude": "30.2630584",
      "poi_longitude": "-81.4443924",
      "poi_miles_from_property": "13",
      "poi_walking_minutes": "4 hours 45 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-953-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-a1a0-71ba-a1df-74b25a69a4a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-a1a0-71ba-a1df-74b25a69a4a4",
        "storage_key": "property/6767906449167307/019d02f7-a1a0-71ba-a1df-74b25a69a4a4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJGyMTif9L5IgR1wq7RoDET3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_9de38d77-c70c-493d-8123-17721193696b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Fort Family Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8000 Baymeadows Rd E, Jacksonville, FL 32256, USA",
      "poi_short_description": "Neighborhood hub providing picnic shelters & grills as well as bleachers, benches & soccer fields.",
      "poi_long_description": "People say this park offers baseball fields, soccer fields, tennis courts, pickleball courts, and walking trails. They highlight the family-friendly atmosphere, the well-maintained facilities, and the scenic views, including a lake with a boardwalk. They also like the covered picnic areas and the ample parking, though parking can be limited during events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-670b-7008-9772-7736c0deef73.webp",
      "poi_featured_image_media": {
        "alt_text": "Fort Family Regional Park at Baymeadows monument sign with colorful flowers and palm trees.",
        "public_id": "019d02f7-670b-7008-9772-7736c0deef73",
        "storage_key": "property/6767906449167307/019d02f7-670b-7008-9772-7736c0deef73.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/9a-baymeadows-regional-park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15899440380805655219&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-family-park",
      "poi_latitude": "30.2243209",
      "poi_longitude": "-81.5104589",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 904-630-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-a4fe-711c-8c71-a637a80e838e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-a4fe-711c-8c71-a637a80e838e",
        "storage_key": "property/6767906449167307/019d02f7-a4fe-711c-8c71-a637a80e838e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxStMsDY15IgRsypsmckoptw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_69249597-6c3f-4ee6-8cac-fa4d1c3f03be",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Losco Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10931 Hood Rd, Jacksonville, FL 32257, USA",
      "poi_short_description": "City green space with a modern play structure & a splash pad, plus snacks, picnic tables & grills.",
      "poi_long_description": "People say this park offers soccer fields, walking trails, a playground, and a splash pad. They highlight the park's clean facilities, shaded areas, and ample parking. They also like the peaceful and welcoming vibe, and the well-maintained trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da1-3528-7529-9f54-3f79e3d96270.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides, swings, and climbing structures in a park setting.",
        "public_id": "019d6da1-3528-7529-9f54-3f79e3d96270",
        "storage_key": "property/6767906449167307/019d6da1-3528-7529-9f54-3f79e3d96270.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.jacksonville.gov/departments/parks-and-recreation/recreation-and-community-programming/parks/richard-h-dick-kravitz-regional-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3456311534261237858&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "losco-regional-park",
      "poi_latitude": "30.1779456",
      "poi_longitude": "-81.566791",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 904-630-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-a4fe-711c-8c71-a637a80e838e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-a4fe-711c-8c71-a637a80e838e",
        "storage_key": "property/6767906449167307/019d02f7-a4fe-711c-8c71-a637a80e838e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ289uEJvL5YgRYvi5MAdJ9y8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2db70b21-0d63-4a25-8b43-7b64eff6851c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Patton Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2850 Hodges Blvd, Jacksonville, FL 32246, USA",
      "poi_short_description": "Spacious park with year-round soccer fields plus a football field, playground & picnic facilities.",
      "poi_long_description": "People say this park offers numerous soccer fields, a playground, and a turf field. They also highlight the ample parking, shade trees, and clean facilities.\n\nOther reviews mention the restrooms can be inadequate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f8-11d3-7209-8f76-48c7ecdfe50a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f8-11d3-7209-8f76-48c7ecdfe50a",
        "storage_key": "property/6767906449167307/019d02f8-11d3-7209-8f76-48c7ecdfe50a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/patton-park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=12607686974899041803&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "patton-park",
      "poi_latitude": "30.2973463",
      "poi_longitude": "-81.4654139",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 904-630-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-a4fe-711c-8c71-a637a80e838e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-a4fe-711c-8c71-a637a80e838e",
        "storage_key": "property/6767906449167307/019d02f7-a4fe-711c-8c71-a637a80e838e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJj0K6kaxL5IgRCzYtWoGA964",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_97975286-f2df-4d8b-947d-21e06dc8a5f4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Jacksonville Drew Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6621 Barnes Rd S, Jacksonville, FL 32216, USA",
      "poi_short_description": "4-diamond softball complex, with nearby picnic areas, outdoor grills & playground equipment.",
      "poi_long_description": "4-diamond softball complex, with nearby picnic areas, outdoor grills & playground equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da1-27d9-7111-9ba7-6af09a521fab.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground area with slides and swings, picnic tables, and covered pavilions.",
        "public_id": "019d6da1-27d9-7111-9ba7-6af09a521fab",
        "storage_key": "property/6767906449167307/019d6da1-27d9-7111-9ba7-6af09a521fab.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/drew-park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3215250752996690344&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jacksonville-drew-park",
      "poi_latitude": "30.2714153",
      "poi_longitude": "-81.5928777",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-731-8477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-a4fe-711c-8c71-a637a80e838e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-a4fe-711c-8c71-a637a80e838e",
        "storage_key": "property/6767906449167307/019d02f7-a4fe-711c-8c71-a637a80e838e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh36dfuW15YgRqMksVIbdniw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_201b70bc-3c5c-41b7-822b-a09f3dea2fc9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "University Of North Florida Nature Trails",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Recreation and Wellness, 1 UNF Dr. Bldg 61, Rm 1200, Jacksonville, FL 32224, USA",
      "poi_short_description": "Walking and hiking trails with ponds and boardwalks.",
      "poi_long_description": "People say this hiking area offers well-maintained trails with scenic views, including a bridge over a pond and an island picnic area. They highlight the peaceful and clean atmosphere, with opportunities to observe wildlife and enjoy nature. They also like the wide trails, ample shade, and the presence of park rangers for safety.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da1-3392-736e-8aa2-a08c42efe08f.webp",
      "poi_featured_image_media": {
        "alt_text": "Serene lake surrounded by lush green trees, with lily pads on the water's surface.",
        "public_id": "019d6da1-3392-736e-8aa2-a08c42efe08f",
        "storage_key": "property/6767906449167307/019d6da1-3392-736e-8aa2-a08c42efe08f.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://www.unf.edu/recwell/ecoadventure/naturetrails.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=15296088774153803538&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-north-florida-nature-trails",
      "poi_latitude": "30.2662108",
      "poi_longitude": "-81.5122718",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 904-620-4769",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9b87-76d3-a516-58e458a8f737",
        "storage_key": "property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9yTxRbJK5IgREhdHrLKfRtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_24494f9e-b22d-466d-879e-995fbc936706",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Johnson & Johnson Vision",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7500 Centurion Pkwy N, Jacksonville, FL 32256, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-877b-7484-aaa8-23c198534fb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f7-877b-7484-aaa8-23c198534fb1",
        "storage_key": "property/6767906449167307/019d02f7-877b-7484-aaa8-23c198534fb1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jjvision.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15831407970170892390&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "johnson--johnson-vision",
      "poi_latitude": "30.2382659",
      "poi_longitude": "-81.5473098",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-443-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9b87-76d3-a516-58e458a8f737",
        "storage_key": "property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo93u6JPK5YgRZvBSpKt1tNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6516567f-4ae8-40ef-8e62-a2388162eabf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Landstar",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13410 Sutton Park Dr S, Jacksonville, FL 32224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da1-5660-7419-b2df-c5a8e209e0da.webp",
      "poi_featured_image_media": {
        "alt_text": "Modern office building with blue glass windows, palm trees, and a waterfront deck.",
        "public_id": "019d6da1-5660-7419-b2df-c5a8e209e0da",
        "storage_key": "property/6767906449167307/019d6da1-5660-7419-b2df-c5a8e209e0da.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.landstar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3629049469249943332&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "landstar",
      "poi_latitude": "30.2533999",
      "poi_longitude": "-81.46240929999999",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-398-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9b87-76d3-a516-58e458a8f737",
        "storage_key": "property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2XIjnlK5IgRJHf2xkP5XDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_dfc0580f-1372-4030-a176-beac25438462",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Dun and Bradstreet",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5335 Gate Pkwy 6th Floor, Jacksonville, FL 32256, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da1-49c9-7712-a3c1-06f6613a9be2.webp",
      "poi_featured_image_media": {
        "alt_text": "Dun & Bradstreet building exterior at night with palm trees and parking lot.",
        "public_id": "019d6da1-49c9-7712-a3c1-06f6613a9be2",
        "storage_key": "property/6767906449167307/019d6da1-49c9-7712-a3c1-06f6613a9be2.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.dnb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11068705384093747404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dun-and-bradstreet",
      "poi_latitude": "30.2492978",
      "poi_longitude": "-81.5268139",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 800-234-3867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9b87-76d3-a516-58e458a8f737",
        "storage_key": "property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn24JvGfL5YgRzIhc_ubwm5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f219d65b-1462-4705-a310-267e27625517",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Johnson & Johnson Vision, R&D Bldg",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Deerwood Park Blvd, Jacksonville, FL 32256, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da1-5831-7228-94eb-6ecd25236b9e.webp",
      "poi_featured_image_media": {
        "alt_text": "A diverse group of people posing for a photo in an office setting.",
        "public_id": "019d6da1-5831-7228-94eb-6ecd25236b9e",
        "storage_key": "property/6767906449167307/019d6da1-5831-7228-94eb-6ecd25236b9e.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8743792001339620126&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "johnson--johnson-vision-rd-bldg",
      "poi_latitude": "30.2446457",
      "poi_longitude": "-81.54399269999999",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9b87-76d3-a516-58e458a8f737",
        "storage_key": "property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD4xq4I3K5YgRHvu_pX8wWHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_382b20d1-e04b-478d-948f-997b43a9d003",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "poi_name": "Pilot Corporation of America (Pilot Pen)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3855 Regent Blvd, Jacksonville, FL 32224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d6da1-5a96-7158-aab0-9668cbb4fd3b.webp",
      "poi_featured_image_media": {
        "alt_text": "Pilot logo and building exterior",
        "public_id": "019d6da1-5a96-7158-aab0-9668cbb4fd3b",
        "storage_key": "property/6767906449167307/019d6da1-5a96-7158-aab0-9668cbb4fd3b.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.pilotpen.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16552016928406949674&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pilot-corporation-of-america-pilot-pen",
      "poi_latitude": "30.2785975",
      "poi_longitude": "-81.5065188",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-645-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f7-9b87-76d3-a516-58e458a8f737",
        "storage_key": "property/6767906449167307/019d02f7-9b87-76d3-a516-58e458a8f737.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU901ichK5IgRKs_yNbOTtOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_5cb48517-32cf-4af5-9fe8-072ad41833dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0ceab6bc-e449-4a2b-ba95-e8ec31159a63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_2545cde6-957d-4131-91c3-18e7f2494a2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_50de284e-01e3-4e89-b154-586394e02647",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_677b97ec-b2b5-48d3-92a3-ba434893d631",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c9a0e873-2682-4634-a71e-f34311492092",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_e79faf5b-ca1b-4160-a95d-45a9eae027b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_a12df00ff7cc3b61277a65f2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "rating": "5",
      "name": "Sydney Mccloud",
      "text": "I love love the community, it well kept up from the parking lot , the grass to the amenity center!! My apartment never has issues!  Coy was my leasing agent. He is amazing he is knowledgeable, communicative, and super sweet. Jeremy also was very nice and welcoming. I definitely will be here for a good time! Also super huge tubs came in so much hand being pregnant lol I never seen an apartment with such a huge bath tub😭🩷!",
      "date": "2025-10-29",
      "title": "false"
    },
    {
      "id": "ec_d3b2de0db05e284b7d929cea",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "rating": "5",
      "name": "letrice philmore",
      "text": "I had an amazing tour with Amyah from the second i walked in she had a big smile on her face. She was fun, kind, listened and knew so much about the apartment complex. Answered all my our questions. Iv been looking for apartments and this was the most inviting tour I have had. The apartments were nice and up to date. Pool area was nice, loved the water veiw.",
      "date": "2026-05-27",
      "title": "false"
    },
    {
      "id": "ec_3003eef6afc67abb84824752",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "rating": "5",
      "name": "Solace Reed",
      "text": "I had a great experience touring the apartment.\nMr.Coy was very personable, welcoming, and made the entire process feel comfortable and stress-free. He took the time to answer all my questions without rushing and really made me feel at ease. The tour itself was thorough and informative, and the space was presented beautifully. Overall, it was a genuinely pleasant experience from start to finish.",
      "date": "2026-01-02",
      "title": "false"
    },
    {
      "id": "ec_c9d710fb02944464821b0a24",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "rating": "5",
      "name": "Frederick Green",
      "text": "I called this location about a month ago, spoke to Amaya. She set up a same day tour for me. When I arrived, I believe she was just coming back from her break but she was very welcoming! She asked what I had in mind as it relates to space and floor plan and showed me several units. I didn't apply at the time, as I wanted to weigh my options and make the best choice. Flash forward to last week, I called back and she remembered me-- which was impressive. We went reviewed a few units and she notified me the one that I wanted before may still be available. I went up to see it and I'll be moving in shortly! I am excited for the move but more importantly the service and assistance that I received. Amaya is very pleasant, professional, and patient. She answered all my questions, some several times over the course of time and I know, without a doubt, that she is someone that I would love to have work in my establishment, even in a leadership capacity. I might have to steal her.. lol. Anyway, if you go to Courtney Meadows, ask for Amaya. Just not all at once. Thanks again for the great service, Amaya!",
      "date": "2026-03-30",
      "title": "false"
    },
    {
      "id": "ec_92ef403d1b82bdad84c42185",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "rating": "5",
      "name": "katheryn bartolec",
      "text": "5 stars all the way! I just toured yesterday and was blown away. The units are modern, spacious, and beautifully updated with stainless steel appliances, high ceilings, open floor plan, etc. The staff (especially Amayah ) were incredibly friendly, knowledgeable, and made the whole experience fun and stress-free. The amenities look top-notch— pool/gym/clubhouse/etc.—and the location is perfect. Everything felt clean, well-maintained, and welcoming. Can’t wait to call this place home! Highly recommend.",
      "date": "2026-02-19",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019d6dd6-b0d6-734c-b12e-173645dc36a4",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "american-landmark-the-vale-at-baymeadows",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307"
    },
    {
      "lead_collector_id": "019d7287-655b-7168-943d-30749d8ef625",
      "lead_source": "LANDING_PAGE",
      "name": "american-landmark-the-vale-at-baymeadows-lp",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307"
    },
    {
      "lead_collector_id": "019eb2f4-ea4f-736e-8b77-34c087c8de7a",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-pool-jacksonville-fl-the-vale-897",
      "search_query": "luxury apartments with pool in Jacksonville FL",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Jacksonville, FL",
      "h2_subtitle": "Discover luxury living at The Vale at Baymeadows. Enjoy a refreshing pool and modern amenities in the heart of Jacksonville's Deerwood community.",
      "page_copy": "Welcome to The Vale at Baymeadows, the epitome of luxury apartments with a pool in Jacksonville, FL. Nestled in the vibrant Deerwood neighborhood, these residences offer an unparalleled living experience with stunning pool and lake views. Relax by our inviting pool or entertain in the outdoor kitchen. \n\nOur apartments feature elegant quartz or granite countertops and sleek white cabinetry. Residents also enjoy the perfect blend of modern comfort and serene surroundings, making The Vale an ideal choice for anyone seeking the best in Jacksonville living. Experience the convenience and charm of The Vale at Baymeadows, your luxurious retreat in Duval County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019f6c13-dc8e-76d1-8368-c48a8d147a1c",
        "storage_key": "property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool | The Vale Jacksonville FL",
      "seo_description": "Find luxury apartments with a pool in Jacksonville, FL at The Vale. Enjoy top amenities in Deerwood. Experience premier living today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "page_item_url": "24-7-fitness-center-apartments-deerwood-the-vale-543",
      "search_query": "24/7 fitness center apartments in Deerwood",
      "category": "Amenity",
      "h1_title": "24/7 Fitness Center Apartments in Deerwood",
      "h2_subtitle": "Experience fitness convenience at The Vale. Enjoy round-the-clock access to our state-of-the-art fitness center right in Deerwood.",
      "page_copy": "Discover the convenience of having a fully equipped, 24/7 fitness center steps from your door at The Vale at Baymeadows. Located in the picturesque Deerwood area, our apartments cater to fitness enthusiasts and those seeking an active lifestyle in Jacksonville, FL. Regardless of your schedule, you can keep up with your fitness goals in our well-appointed gym.\n\nBeyond the fitness center, The Vale offers a host of luxury amenities including an outdoor kitchen and beautiful sundeck with scenic views of the pool and lake. Experience the perfect balance of comfort, convenience, and wellness in one of Deerwood’s premier apartment communities. Enhance your lifestyle today at The Vale at Baymeadows.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019f6c13-dc8e-76d1-8368-c48a8d147a1c",
        "storage_key": "property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24/7 Fitness Center Apartments | The Vale Deerwood",
      "seo_description": "Live in Deerwood with a 24/7 fitness center. The Vale offers premier access to fitness and luxury living. Discover your new Jacksonville home today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "page_item_url": "apartments-scenic-lake-views-duval-county-the-vale-877",
      "search_query": "apartments with scenic lake views Duval County",
      "category": "Amenity",
      "h1_title": "Apartments with Scenic Lake Views in Duval County",
      "h2_subtitle": "The Vale at Baymeadows offers breathtaking lake views. Experience serene living in Duval County's Deerwood neighborhood.",
      "page_copy": "For those seeking apartments with scenic lake views in Duval County, The Vale at Baymeadows is the perfect choice. Located in the idyllic Deerwood community, our apartments provide residents with picturesque views that soothe the soul. Wake up to the tranquil beauty of the lake, providing a serene start to every day.\n\nIn addition to stunning views, The Vale offers a range of luxury amenities including a refreshing pool, outdoor kitchen, and sundeck. Whether you're enjoying a quiet moment by the water or entertaining friends, The Vale at Baymeadows delivers an extraordinary living experience in Jacksonville, blending comfort and natural beauty seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019f6c13-dc8e-76d1-8368-c48a8d147a1c",
        "storage_key": "property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Scenic Lake View Apartments | The Vale Duval County",
      "seo_description": "Find apartments with scenic lake views in Duval County at The Vale. Enjoy Deerwood's natural beauty paired with luxury amenities. Discover tranquility today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "page_item_url": "jacksonville-apartments-outdoor-kitchens-the-vale-462",
      "search_query": "Jacksonville apartments with outdoor kitchens",
      "category": "Amenity",
      "h1_title": "Jacksonville Apartments with Outdoor Kitchens",
      "h2_subtitle": "The Vale at Baymeadows offers stylish outdoor kitchens. Enhance your outdoor living experience in Jacksonville.",
      "page_copy": "Elevate your lifestyle with Jacksonville apartments featuring outdoor kitchens at The Vale at Baymeadows. Situated in the charming Deerwood neighborhood, these residences offer the perfect blend of luxury and functionality. Enjoy cooking and dining al fresco with friends and family in our fully-equipped outdoor kitchen, designed to make entertaining effortless.\n\nBeyond the outdoor kitchen, residents can enjoy sleek interiors with quartz or granite countertops and stunning lake views. The Vale at Baymeadows strikes a perfect balance between indoor elegance and outdoor living, making it a premier choice for anyone seeking a unique apartment experience in Duval County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019f6c13-dc8e-76d1-8368-c48a8d147a1c",
        "storage_key": "property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Jacksonville Apartments | Outdoor Kitchens at The Vale",
      "seo_description": "Explore Jacksonville apartments with outdoor kitchens at The Vale. Enjoy state-of-the-art amenities in the heart of Deerwood. Upgrade your lifestyle now.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "page_item_url": "detached-garages-baymeadows-rd-apartments-the-vale-775",
      "search_query": "detached garages in Baymeadows Rd apartments",
      "category": "Amenity",
      "h1_title": "Detached Garages in Baymeadows Rd Apartments",
      "h2_subtitle": "The Vale at Baymeadows offers the convenience of detached garages. Secure and private parking options in Jacksonville's vibrant neighborhood.",
      "page_copy": "Experience the convenience of detached garages at The Vale at Baymeadows, ideally located along Baymeadows Rd in Jacksonville. Our apartment community not only provides luxurious living spaces but also offers secure, private parking solutions with our detached garages. Enjoy peace of mind knowing your vehicle is safe and protected, easily accessible whenever you need.\n\nIn addition to secure parking, The Vale boasts a range of high-end amenities, from sleek white cabinetry and countertops in kitchens to scenic pool views. Enhance your lifestyle with the unique benefits of detached garages combined with the luxury and comfort of living in the Deerwood neighborhood. The Vale is the ideal choice for those who seek both convenience and elegance.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019f6c13-dc8e-76d1-8368-c48a8d147a1c",
        "storage_key": "property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Detached Garages at Baymeadows Rd | The Vale Apartments",
      "seo_description": "Find Baymeadows Rd apartments with detached garages at The Vale. Enjoy secure parking and luxury living in Jacksonville's sought-after Deerwood area.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-jacksonville-fl-the-vale-240",
      "search_query": "one bedroom apartments in Jacksonville FL",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Jacksonville, FL",
      "h2_subtitle": "Discover elegant one bedroom apartments at The Vale. Conveniently located in Jacksonville, FL's Deerwood neighborhood.",
      "page_copy": "Discover the perfect blend of comfort and style in our one bedroom apartments in Jacksonville, FL, at The Vale at Baymeadows. Nestled in the desirable Deerwood neighborhood, these apartments offer lush surroundings and modern features. Enjoy the spacious layouts designed with sleek cabinetry, quartz or granite countertops, and captivating views, enhancing your daily living experience.\n\nThe Vale provides more than just a place to live. Residents have access to premium amenities including a sundeck and an outdoor kitchen perfect for gatherings. Take a leisurely stroll around the scenic lake or relax by the pool, all while enjoying the vibrant community atmosphere. Choose The Vale for a refreshed living experience in a prime Jacksonville location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019f6c13-dc8e-76d1-8368-c48a8d147a1c",
        "storage_key": "property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments | The Vale Jacksonville FL",
      "seo_description": "Explore one bedroom apartments in Jacksonville, FL at The Vale. Enjoy modern amenities and scenic views in the welcoming Deerwood community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-near-deerwood-the-vale-225",
      "search_query": "two bedroom apartments near Deerwood",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Deerwood",
      "h2_subtitle": "Discover spacious two bedroom apartments at The Vale. Located close to Deerwood in Jacksonville, FL, offering modern living with premium amenities.",
      "page_copy": "Looking for two bedroom apartments near Deerwood? The Vale at Baymeadows offers the ideal blend of comfort and convenience in the heart of Jacksonville, FL. Our two bedroom units feature modern finishes, from quartz or granite countertops to sleek cabinetry, designed to make life stylish and easy. With ample living space, these apartments are perfect for those who need additional room or desire a home office setup.\n\nBeyond the thoughtfully designed interiors, residents of The Vale enjoy a variety of luxurious amenities. Spend sunny afternoons by our sundeck or host gatherings at the outdoor kitchen. With scenic lake and pool views enhancing the ambiance, The Vale is more than just a place to live—it's a community that caters to a refined lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019f6c13-dc8e-76d1-8368-c48a8d147a1c",
        "storage_key": "property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments | The Vale Near Deerwood",
      "seo_description": "Find two bedroom apartments near Deerwood at The Vale, Jacksonville. Experience modern comfort and luxury amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-duval-county-the-vale-230",
      "search_query": "three bedroom apartments in Duval County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Duval County",
      "h2_subtitle": "Explore spacious three bedroom apartments at The Vale. Located in vibrant Duval County, these units offer expansive living with lake views and modern amenities.",
      "page_copy": "If you’re searching for spacious three bedroom apartments in Duval County, The Vale at Baymeadows is the perfect choice. Our expansive layouts provide ample room for families, roommates, or anyone requiring extra living space in Jacksonville, FL. Features include modern finishes like quartz or granite countertops and sleek cabinetry, ensuring a blend of function and elegance that complements any lifestyle.\n\nThe Vale isn’t just about stunning interiors. Our community offers exclusive amenities such as a scenic sundeck, an outdoor kitchen, and tranquil lake and pool views. Located in the desirable Deerwood neighborhood, The Vale combines suburban charm with urban convenience, making it a top choice for anyone seeking a three bedroom home in Duval County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019f6c13-dc8e-76d1-8368-c48a8d147a1c",
        "storage_key": "property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments | The Vale Duval County",
      "seo_description": "Discover three bedroom apartments in Duval County at The Vale. Enjoy spacious living with modern amenities and beautiful surroundings in Jacksonville.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "page_item_url": "apartments-near-university-of-north-florida-the-vale-427",
      "search_query": "apartments near university of north florida jacksonville",
      "category": "School",
      "h1_title": "Apartments Near University of North Florida",
      "h2_subtitle": "Find ideal living at The Vale, close to the University of North Florida. Experience modern amenities and comfortable spaces in vibrant Jacksonville.",
      "page_copy": "Just a short drive from the University of North Florida, The Vale at Baymeadows offers the perfect setting for students and faculty seeking off-campus apartments in Jacksonville. Nestled in the serene Deerwood neighborhood, these thoughtfully designed apartments boast sleek cabinetry, quartz or granite countertops, and picturesque lake and pool views, making them an excellent choice for those desiring a peaceful yet convenient living environment.\n\nThe community amenities take living at The Vale to the next level. Residents can unwind at the sundeck, enjoy BBQ evenings at the outdoor kitchen, or simply relax by the pool. With its strategic location near UNF and its range of top-notch facilities, The Vale at Baymeadows stands out as a premium choice for anyone connected to the university and looking for comfortable, accessible living in Duval County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019f6c13-dc8e-76d1-8368-c48a8d147a1c",
        "storage_key": "property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "UNF Apartments | The Vale Near University of North Florida",
      "seo_description": "Discover modern apartments near the University of North Florida at The Vale. Enjoy comfortable, convenient living in Jacksonville's Deerwood neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "page_item_url": "apartments-close-to-fscj-deerwood-center-the-vale-685",
      "search_query": "apartments close to fscj deerwood center duval county",
      "category": "School",
      "h1_title": "Apartments Close to FSCJ Deerwood Center",
      "h2_subtitle": "Discover comfortable living at The Vale, conveniently close to FSCJ Deerwood Center. Enjoy modern amenities and easy access to Duval County's resources.",
      "page_copy": "Positioned perfectly for those attending or working at FSCJ Deerwood Center, The Vale at Baymeadows offers unrivaled convenience with stylish apartment living in Duval County. Our well-appointed apartments are designed with sleek white cabinetry and elegant quartz or granite countertops, providing a functional and contemporary living space ideal for students and professionals alike.\n\nBeyond the well-designed interiors, The Vale enhances your lifestyle with a suite of amenities, including an inviting outdoor kitchen, a relaxing sundeck, and captivating lake and pool views. Located in the attractive Deerwood neighborhood, our community not only offers close proximity to FSCJ Deerwood Center but also ensures residents have access to Jacksonville's finest shopping, dining, and entertainment options. Embrace a convenient, enriching living experience at The Vale.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019f6c13-dc8e-76d1-8368-c48a8d147a1c",
        "storage_key": "property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "FSCJ Deerwood Center Apartments | The Vale Duval",
      "seo_description": "Find apartments close to FSCJ Deerwood Center at The Vale. Experience stylish living with modern amenities in Jacksonville's Duval County.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "page_item_url": "apartments-near-florida-state-college-south-campus-the-vale-648",
      "search_query": "apartments near florida state college jacksonville south campus",
      "category": "School",
      "h1_title": "Apartments Near Florida State College South Campus",
      "h2_subtitle": "The Vale offers convenient living near Florida State College South Campus. Discover modern apartments with easy access to Jacksonville's top attractions.",
      "page_copy": "For those looking to reside near Florida State College Jacksonville South Campus, The Vale at Baymeadows provides the perfect blend of comfort and convenience. Our apartments feature contemporary designs with sleek cabinetry and luxurious quartz or granite countertops, catering to the lifestyle needs of students and staff.\n\nSituated in the vibrant Deerwood neighborhood, The Vale's location allows for quick commutes and easy access to Jacksonville's diverse offerings. Residents can enjoy community amenities like a scenic sundeck, an outdoor kitchen for social gatherings, and tranquil lake and pool views. Living at The Vale empowers you to thrive academically and socially, making it an excellent choice for anyone connected to Florida State College's South Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019f6c13-dc8e-76d1-8368-c48a8d147a1c",
        "storage_key": "property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "FSCJ South Campus Apartments | The Vale Jacksonville",
      "seo_description": "Explore modern apartments near Florida State College South Campus at The Vale. Enjoy convenience and comfort in Jacksonville's lively Deerwood neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "page_item_url": "apartments-near-mayo-clinic-mangurian-building-the-vale-668",
      "search_query": "apartments near Mayo Clinic Mangurian Building Jacksonville FL",
      "category": "Hospital",
      "h1_title": "Apartments Near Mayo Clinic Mangurian Building",
      "h2_subtitle": "The Vale offers stylish, comfortable living near Mayo Clinic's Mangurian Building. Enjoy modern amenities and convenient access in Jacksonville.",
      "page_copy": "Located conveniently near the Mayo Clinic Mangurian Building in Jacksonville, The Vale at Baymeadows creates an ideal home base for healthcare professionals and patients seeking short or extended stays. Our tastefully designed apartments feature modern touches, like sleek cabinetry and premium quartz or granite countertops, ensuring a welcoming and comfortable environment.\n\nResiding in the serene neighborhood of Deerwood, The Vale provides not only easy access to the Mayo Clinic but also offers a host of onsite amenities. Residents can unwind by the pool, socialize at the outdoor kitchen, or relax on the sundeck while taking in the scenic lake views. Choose The Vale for its prime location and enjoy a seamless living experience that supports both your personal and professional needs in Duval County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019f6c13-dc8e-76d1-8368-c48a8d147a1c",
        "storage_key": "property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mayo Clinic Jacksonville Apartments | The Vale Nearby",
      "seo_description": "Discover apartments near Mayo Clinic Jacksonville at The Vale. Experience comfort and convenience in Duval County's beautiful Deerwood neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "page_item_url": "apartments-near-fort-family-park-the-vale-456",
      "search_query": "apartments near Fort Family Park Jacksonville",
      "category": "Park",
      "h1_title": "Apartments Near Fort Family Park Jacksonville",
      "h2_subtitle": "Enjoy living near Fort Family Park at The Vale. Discover modern apartments with excellent amenities and outdoor fun in Jacksonville's Deerwood area.",
      "page_copy": "Nestled near Fort Family Park in Jacksonville, The Vale at Baymeadows offers a perfect retreat for those looking to combine urban living with outdoor exploration. Our community not only provides modern apartments with luxurious features like sleek white cabinetry and rich quartz or granite countertops but also opens doors to exciting recreational opportunities at the nearby park.\n\nLocated in the charming Deerwood neighborhood, residents at The Vale enjoy unmatched amenities such as a scenic sundeck, serene pool settings, and an outdoor kitchen perfect for social gatherings. With Fort Family Park just a stone's throw away, you can indulge in jogging, picnics, and family outings, making The Vale an ideal choice for active individuals and families seeking a vibrant lifestyle amidst Jacksonville's natural beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019f6c13-dc8e-76d1-8368-c48a8d147a1c",
        "storage_key": "property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fort Family Park Apartments | The Vale Jacksonville",
      "seo_description": "Live near Fort Family Park in Jacksonville at The Vale. Experience modern living with great amenities in the picturesque Deerwood neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "page_item_url": "apartments-close-to-losco-regional-park-the-vale-6",
      "search_query": "apartments close to Losco Regional Park 32256",
      "category": "Park",
      "h1_title": "Apartments Close to Losco Regional Park",
      "h2_subtitle": "Discover The Vale, close to Losco Regional Park. Enjoy modern living with nature at your doorstep in Jacksonville, FL 32256.",
      "page_copy": "For those who love the outdoors, The Vale at Baymeadows offers an ideal place to call home, perfectly situated close to Losco Regional Park in Jacksonville, FL 32256. Our stylish apartments boast chic designs with sleek cabinetry and luxurious quartz or granite countertops, complemented by picturesque views perfect for connecting with nature.\n\nLocated in the inviting Deerwood area, our residents not only enjoy proximity to the expansive Losco Regional Park but also an array of exceptional community amenities. Spend your weekends lounging by the pool, or entertain friends at the outdoor kitchen while savoring the lake views. The Vale provides a harmonious blend of modern comfort and natural beauty, making it the ultimate residence for those seeking the perfect balance in Jacksonville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019f6c13-dc8e-76d1-8368-c48a8d147a1c",
        "storage_key": "property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Losco Regional Park Apartments | The Vale Jacksonville",
      "seo_description": "Find apartments close to Losco Regional Park at The Vale in Jacksonville, FL 32256. Experience seamless living with access to nature and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "page_item_url": "apartments-by-patton-park-the-vale-deerwood-65",
      "search_query": "apartments by Patton Park Deerwood",
      "category": "Park",
      "h1_title": "Apartments by Patton Park Deerwood",
      "h2_subtitle": "Choose The Vale at Baymeadows, near Patton Park in Deerwood. Enjoy luxurious living with convenient access to recreation and relaxation in Jacksonville.",
      "page_copy": "Located in the vibrant area of Deerwood, The Vale at Baymeadows offers upscale apartments just moments away from Patton Park. Enjoy the convenience of having access to various recreational activities while residing in an apartment that provides a blend of comfort and style, complete with sleek white cabinetry and beautiful quartz or granite countertops.\n\nLiving at The Vale means experiencing the best of Jacksonville's natural beauty and modern amenities. Residents can relax at the sundeck, take in panoramic lake and pool views, or have a friendly gathering around the outdoor kitchen. With Patton Park nearby, you can easily enjoy outdoor activities, making The Vale an ideal choice for those who want a balanced lifestyle combining relaxation and recreation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019f6c13-dc8e-76d1-8368-c48a8d147a1c",
        "storage_key": "property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Patton Park | The Vale Deerwood FL",
      "seo_description": "Discover The Vale's luxury apartments by Patton Park in Deerwood. Enjoy modern amenities and close proximity to recreation in Jacksonville, FL.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167307",
      "source": "custom",
      "page_item_url": "drew-park-duval-county-nearby-apartments-the-vale-90",
      "search_query": "Drew Park Duval County nearby apartments",
      "category": "Park",
      "h1_title": "Nearby Apartments to Drew Park Duval County",
      "h2_subtitle": "Explore The Vale, situated conveniently near Drew Park in Duval County. Experience upscale living with Jacksonville's best features at your doorstep.",
      "page_copy": "Experience life at The Vale at Baymeadows, strategically located near Drew Park in Duval County. Our luxurious apartments provide residents with an exceptional living experience, offering modern finishes such as sleek white cabinetry and elegant quartz or granite countertops. With Drew Park just minutes away, outdoor enthusiasts will appreciate the convenient access to a range of recreational activities right in their neighborhood.\n\nBeyond our beautiful interiors, The Vale features outstanding community amenities that complement its prime location. Relax by the scenic pool or entertain guests in the outdoor kitchen while enjoying the stunning lake views. Positioned in Jacksonville's Deerwood area, The Vale offers an ideal spot for those seeking a dynamic lifestyle with easy access to both the tranquility of nature and the vibrancy of city life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "019f6c13-dc8e-76d1-8368-c48a8d147a1c",
        "storage_key": "property/6767906449167307/019f6c13-dc8e-76d1-8368-c48a8d147a1c.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Drew Park Apartments | The Vale Duval County FL",
      "seo_description": "Find the perfect apartment close to Drew Park in Duval County at The Vale. Enjoy luxury living with easy access to recreation and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6044"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11526526456"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69e5d971a72b954aeb361508\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69e5d971a72b954aeb361508\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5648091"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TXBZM538"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "4"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "52980507672"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "cea11f1c9b5c7aab"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/9zw4zl36v87"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "904-921-3081"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IitscUFnRmYxZnB2RVAzcmlvQUkvL1E9PSIsInZhbHVlIjoiV0h3bFczT01HZGlVd3RGaC9oV1l0Zz09IiwibWFjIjoiMTgzMjkzZjBlYjIxNzYzNDU4MzY3OTVhZjI3MTQwODcyMTRmYjU3NDFhMzVlM2Q1ZjgyN2IyYTY5MDM3ODdiNSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_qb_id": "6044",
  "custom_repli_id": "11526526456",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69e5d971a72b954aeb361508\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69e5d971a72b954aeb361508\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "5648091",
  "custom_google_gtm_id": "GTM-TXBZM538",
  "custom_rollout_phase": "4",
  "custom_knock_company_id": "3165",
  "custom_hubspot_company_id": "52980507672",
  "custom_knock_community_id": "cea11f1c9b5c7aab",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/9zw4zl36v87",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "904-921-3081",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IitscUFnRmYxZnB2RVAzcmlvQUkvL1E9PSIsInZhbHVlIjoiV0h3bFczT01HZGlVd3RGaC9oV1l0Zz09IiwibWFjIjoiMTgzMjkzZjBlYjIxNzYzNDU4MzY3OTVhZjI3MTQwODcyMTRmYjU3NDFhMzVlM2Q1ZjgyN2IyYTY5MDM3ODdiNSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "da30333d-ec63-4390-9f1a-b5bb7f98def9",
  "custom_audioeye_site_hash": "896bd1f9d87b97dfc752b3b3b59176e8"
};

export const generatedAt = '2026-10-05T16:19:24.026Z';
